import { useCanvasStore, useCanvasActions, useUndoRedoShortcuts, syncFromWasm, getNumericId, getAssetStringId, getAssetMetadata, registerAsset, setAssetMetadata, updateAssetColor } from './chunk-UEPGDLLX.js';
export { getAssetMetadata, setAssetMetadata, updateAssetColor } from './chunk-UEPGDLLX.js';
import { generateAssetId } from './chunk-4B3W7KT2.js';
export { generateAssetId, isAsset, isCanvasAsset, isImageAsset, isShapeAsset, isTextAsset, isVideoAsset } from './chunk-4B3W7KT2.js';
import { __commonJS } from './chunk-556IGTOR.js';
import * as React2 from 'react';
import { createContext, memo, useRef, useState, useEffect, useMemo, useCallback, forwardRef, useImperativeHandle, useContext } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Cursor, Hand, ArrowCounterClockwise, ArrowClockwise, MagnifyingGlassMinus, MagnifyingGlassPlus, ArrowsOutSimple, Plus, Trash, Palette } from 'phosphor-react';
import Konva from 'konva';
import { Stage, Layer, Transformer, Rect, Image as Image$1 } from 'react-konva';
export { Editor } from '@convadraw/editor';
export { Box, Vec, snapToGrid, uniqueId } from '@convadraw/primitives';

// src/lib/hammer-konva.cjs
var require_hammer_konva = __commonJS({
  "src/lib/hammer-konva.cjs"(exports$1, module) {
    (function(window2, document2, exportName, undefined2) {
      var VENDOR_PREFIXES = ["", "webkit", "Moz", "MS", "ms", "o"];
      var TEST_ELEMENT = document2.createElement("div");
      var TYPE_FUNCTION = "function";
      var round = Math.round;
      var abs = Math.abs;
      var now = Date.now;
      function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
      }
      function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
          each(arg, context[fn], context);
          return true;
        }
        return false;
      }
      function each(obj, iterator, context) {
        var i;
        if (!obj) {
          return;
        }
        if (obj.forEach) {
          obj.forEach(iterator, context);
        } else if (obj.length !== undefined2) {
          i = 0;
          while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
          }
        } else {
          for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
          }
        }
      }
      function deprecate(method, name, message) {
        var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
        return function() {
          var e = new Error("get-stack-trace");
          var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
          var log = window2.console && (window2.console.warn || window2.console.log);
          if (log) {
            log.call(window2.console, deprecationMessage, stack);
          }
          return method.apply(this, arguments);
        };
      }
      var assign;
      if (typeof Object.assign !== "function") {
        assign = function assign2(target) {
          if (target === undefined2 || target === null) {
            throw new TypeError("Cannot convert undefined or null to object");
          }
          var output = Object(target);
          for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined2 && source !== null) {
              for (var nextKey in source) {
                if (source.hasOwnProperty(nextKey)) {
                  output[nextKey] = source[nextKey];
                }
              }
            }
          }
          return output;
        };
      } else {
        assign = Object.assign;
      }
      var extend = deprecate(
        function extend2(dest, src, merge2) {
          var keys = Object.keys(src);
          var i = 0;
          while (i < keys.length) {
            if (!merge2 || merge2 && dest[keys[i]] === undefined2) {
              dest[keys[i]] = src[keys[i]];
            }
            i++;
          }
          return dest;
        },
        "extend",
        "Use `assign`."
      );
      var merge = deprecate(
        function merge2(dest, src) {
          return extend(dest, src, true);
        },
        "merge",
        "Use `assign`."
      );
      function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) {
          assign(childP, properties);
        }
      }
      function bindFn(fn, context) {
        return function boundFn() {
          return fn.apply(context, arguments);
        };
      }
      function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) {
          return val.apply(args ? args[0] || undefined2 : undefined2, args);
        }
        return val;
      }
      function ifUndefined(val1, val2) {
        return val1 === undefined2 ? val2 : val1;
      }
      function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
          target.addEventListener(type, handler, false);
        });
      }
      function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
          target.removeEventListener(type, handler, false);
        });
      }
      function hasParent(node, parent) {
        while (node) {
          if (node == parent) {
            return true;
          }
          node = node.parentNode;
        }
        return false;
      }
      function inStr(str, find) {
        return str.indexOf(find) > -1;
      }
      function splitStr(str) {
        return str.trim().split(/\s+/g);
      }
      function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) {
          return src.indexOf(find);
        } else {
          var i = 0;
          while (i < src.length) {
            if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) {
              return i;
            }
            i++;
          }
          return -1;
        }
      }
      function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
      }
      function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while (i < src.length) {
          var val = src[i][key] ;
          if (inArray(values, val) < 0) {
            results.push(src[i]);
          }
          values[i] = val;
          i++;
        }
        {
          {
            results = results.sort(function sortUniqueArray(a, b) {
              return a[key] > b[key];
            });
          }
        }
        return results;
      }
      function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while (i < VENDOR_PREFIXES.length) {
          prefix = VENDOR_PREFIXES[i];
          prop = prefix ? prefix + camelProp : property;
          if (prop in obj) {
            return prop;
          }
          i++;
        }
        return undefined2;
      }
      var _uniqueId = 1;
      function uniqueId2() {
        return _uniqueId++;
      }
      function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window2;
      }
      var INPUT_TYPE_TOUCH = "touch";
      var INPUT_TYPE_PEN = "pen";
      var INPUT_TYPE_MOUSE = "mouse";
      var INPUT_TYPE_KINECT = "kinect";
      var COMPUTE_INTERVAL = 25;
      var INPUT_START = 1;
      var INPUT_MOVE = 2;
      var INPUT_END = 4;
      var INPUT_CANCEL = 8;
      var DIRECTION_NONE = 1;
      var DIRECTION_LEFT = 2;
      var DIRECTION_RIGHT = 4;
      var DIRECTION_UP = 8;
      var DIRECTION_DOWN = 16;
      var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
      var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
      var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
      var PROPS_XY = ["x", "y"];
      var PROPS_CLIENT_XY = ["clientX", "clientY"];
      function Input(manager, callback) {
        var self2 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        this.domHandler = function(ev) {
          if (boolOrFn(manager.options.enable, [manager])) {
            self2.handler(ev);
          }
        };
        this.init();
      }
      Input.prototype = {
        /**
         * should handle the inputEvent data and trigger the callback
         * @virtual
         */
        handler: function() {
        },
        /**
         * bind the events
         */
        init: function() {
          this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
          this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
          this.evWin && addEventListeners(
            getWindowForElement(this.element),
            this.evWin,
            this.domHandler
          );
        },
        /**
         * unbind the events
         */
        destroy: function() {
          this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
          this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
          this.evWin && removeEventListeners(
            getWindowForElement(this.element),
            this.evWin,
            this.domHandler
          );
        }
      };
      function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) {
          Type = inputClass;
        } else {
          Type = TouchInput;
        }
        return new Type(manager, inputHandler);
      }
      function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) {
          manager.session = {};
        }
        input.eventType = eventType;
        computeInputData(manager, input);
        manager.emit("hammer.input", input);
        manager.recognize(input);
        manager.session.prevInput = input;
      }
      function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        if (!session.firstInput) {
          session.firstInput = simpleCloneInputData(input);
        }
        if (pointersLength > 1 && !session.firstMultiple) {
          session.firstMultiple = simpleCloneInputData(input);
        } else if (pointersLength === 1) {
          session.firstMultiple = false;
        }
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(
          input.deltaTime,
          input.deltaX,
          input.deltaY
        );
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) {
          target = input.srcEvent.target;
        }
        input.target = target;
      }
      function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
          prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
          };
          offset = session.offsetDelta = {
            x: center.x,
            y: center.y
          };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
      }
      function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined2)) {
          var deltaX = input.deltaX - last.deltaX;
          var deltaY = input.deltaY - last.deltaY;
          var v = getVelocity(deltaTime, deltaX, deltaY);
          velocityX = v.x;
          velocityY = v.y;
          velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
          direction = getDirection(deltaX, deltaY);
          session.lastInterval = input;
        } else {
          velocity = last.velocity;
          velocityX = last.velocityX;
          velocityY = last.velocityY;
          direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
      }
      function simpleCloneInputData(input) {
        var pointers = [];
        var i = 0;
        while (i < input.pointers.length) {
          pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
          };
          i++;
        }
        return {
          timeStamp: now(),
          pointers,
          center: getCenter(pointers),
          deltaX: input.deltaX,
          deltaY: input.deltaY
        };
      }
      function getCenter(pointers) {
        var pointersLength = pointers.length;
        if (pointersLength === 1) {
          return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
          };
        }
        var x = 0, y = 0, i = 0;
        while (i < pointersLength) {
          x += pointers[i].clientX;
          y += pointers[i].clientY;
          i++;
        }
        return {
          x: round(x / pointersLength),
          y: round(y / pointersLength)
        };
      }
      function getVelocity(deltaTime, x, y) {
        return {
          x: x / deltaTime || 0,
          y: y / deltaTime || 0
        };
      }
      function getDirection(x, y) {
        if (x === y) {
          return DIRECTION_NONE;
        }
        if (abs(x) >= abs(y)) {
          return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        }
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
      }
      function getDistance(p1, p2, props) {
        if (!props) {
          props = PROPS_XY;
        }
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
      }
      function getAngle(p1, p2, props) {
        if (!props) {
          props = PROPS_XY;
        }
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
      }
      function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
      }
      function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
      }
      var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
      };
      var MOUSE_ELEMENT_EVENTS = "mousedown";
      var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
      function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false;
        Input.apply(this, arguments);
      }
      inherit(MouseInput, Input, {
        /**
         * handle mouse events
         * @param {Object} ev
         */
        handler: function MEhandler(ev) {
          var eventType = MOUSE_INPUT_MAP[ev.type];
          if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
          }
          if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
          }
          if (!this.pressed) {
            return;
          }
          if (eventType & INPUT_END) {
            this.pressed = false;
          }
          this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
          });
        }
      });
      var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
      };
      var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT
        // see https://twitter.com/jacobrossi/status/480596438489890816
      };
      var POINTER_ELEMENT_EVENTS = "pointerdown";
      var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
      if (window2.MSPointerEvent && !window2.PointerEvent) {
        POINTER_ELEMENT_EVENTS = "MSPointerDown";
        POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
      }
      function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
      }
      inherit(PointerEventInput, Input, {
        /**
         * handle mouse events
         * @param {Object} ev
         */
        handler: function PEhandler(ev) {
          var store = this.store;
          var removePointer = false;
          var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
          var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
          var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
          var isTouch = pointerType == INPUT_TYPE_TOUCH;
          var storeIndex = inArray(store, ev.pointerId, "pointerId");
          if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
              store.push(ev);
              storeIndex = store.length - 1;
            }
          } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
          }
          if (storeIndex < 0) {
            return;
          }
          store[storeIndex] = ev;
          this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType,
            srcEvent: ev
          });
          if (removePointer) {
            store.splice(storeIndex, 1);
          }
        }
      });
      var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
      };
      var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
      var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
      function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
      }
      inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
          var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
          if (type === INPUT_START) {
            this.started = true;
          }
          if (!this.started) {
            return;
          }
          var touches = normalizeSingleTouches.call(this, ev, type);
          if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
          }
          this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
          });
        }
      });
      function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) {
          all = uniqueArray(all.concat(changed), "identifier");
        }
        return [all, changed];
      }
      var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
      };
      var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
      function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
      }
      inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
          var type = TOUCH_INPUT_MAP[ev.type];
          var touches = getTouches.call(this, ev, type);
          if (!touches) {
            return;
          }
          this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
          });
        }
      });
      function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
          targetIds[allTouches[0].identifier] = true;
          return [allTouches, allTouches];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = []; this.target;
        targetTouches = allTouches.filter(function(touch) {
          return true;
        });
        if (type === INPUT_START) {
          i = 0;
          while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
          }
        }
        i = 0;
        while (i < changedTouches.length) {
          if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
          }
          if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
          }
          i++;
        }
        if (!changedTargetTouches.length) {
          return;
        }
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          uniqueArray(
            targetTouches.concat(changedTargetTouches),
            "identifier"),
          changedTargetTouches
        ];
      }
      var DEDUP_TIMEOUT = 2500;
      function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
      }
      inherit(TouchMouseInput, Input, {
        /**
         * handle mouse and touch events
         * @param {Hammer} manager
         * @param {String} inputEvent
         * @param {Object} inputData
         */
        handler: function TMEhandler(manager, inputEvent, inputData) {
          var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
          if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
          }
          if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
          } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
          }
          this.callback(manager, inputEvent, inputData);
        },
        /**
         * remove the event listeners
         */
        destroy: function destroy() {
          this.touch.destroy();
          this.mouse.destroy();
        }
      });
      function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
          this.primaryTouch = eventData.changedPointers[0].identifier;
          setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
          setLastTouch.call(this, eventData);
        }
      }
      function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
          var lastTouch = { x: touch.clientX, y: touch.clientY };
          this.lastTouches.push(lastTouch);
          var lts = this.lastTouches;
          var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
              lts.splice(i, 1);
            }
          };
          setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
      }
      function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for (var i = 0; i < this.lastTouches.length; i++) {
          var t = this.lastTouches[i];
          var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
          if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
          }
        }
        return false;
      }
      var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
      var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined2;
      var TOUCH_ACTION_COMPUTE = "compute";
      var TOUCH_ACTION_AUTO = "auto";
      var TOUCH_ACTION_MANIPULATION = "manipulation";
      var TOUCH_ACTION_NONE = "none";
      var TOUCH_ACTION_PAN_X = "pan-x";
      var TOUCH_ACTION_PAN_Y = "pan-y";
      var TOUCH_ACTION_MAP = getTouchActionProps();
      function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
      }
      TouchAction.prototype = {
        /**
         * set the touchAction value on the element or enable the polyfill
         * @param {String} value
         */
        set: function(value) {
          if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
          }
          if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
          }
          this.actions = value.toLowerCase().trim();
        },
        /**
         * just re-set the touchAction value
         */
        update: function() {
          this.set(this.manager.options.touchAction);
        },
        /**
         * compute the value for the touchAction property based on the recognizer's settings
         * @returns {String} value
         */
        compute: function() {
          var actions = [];
          each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
              actions = actions.concat(recognizer.getTouchAction());
            }
          });
          return cleanTouchActions(actions.join(" "));
        },
        /**
         * this method is called on each input cycle and provides the preventing of the browser behavior
         * @param {Object} input
         */
        preventDefaults: function(input) {
          var srcEvent = input.srcEvent;
          var direction = input.offsetDirection;
          if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
          }
          var actions = this.actions;
          var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
          var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
          var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
          if (hasNone) {
            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;
            if (isTapPointer && isTapMovement && isTapTouchTime) {
              return;
            }
          }
          if (hasPanX && hasPanY) {
            return;
          }
          if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) {
            return this.preventSrc(srcEvent);
          }
        },
        /**
         * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
         * @param {Object} srcEvent
         */
        preventSrc: function(srcEvent) {
          this.manager.session.prevented = true;
          srcEvent.preventDefault();
        }
      };
      function cleanTouchActions(actions) {
        if (inStr(actions, TOUCH_ACTION_NONE)) {
          return TOUCH_ACTION_NONE;
        }
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        if (hasPanX && hasPanY) {
          return TOUCH_ACTION_NONE;
        }
        if (hasPanX || hasPanY) {
          return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        }
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
          return TOUCH_ACTION_MANIPULATION;
        }
        return TOUCH_ACTION_AUTO;
      }
      function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) {
          return false;
        }
        var touchMap = {};
        var cssSupports = window2.CSS && window2.CSS.supports;
        ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(
          function(val) {
            touchMap[val] = cssSupports ? window2.CSS.supports("touch-action", val) : true;
          }
        );
        return touchMap;
      }
      var STATE_POSSIBLE = 1;
      var STATE_BEGAN = 2;
      var STATE_CHANGED = 4;
      var STATE_ENDED = 8;
      var STATE_RECOGNIZED = STATE_ENDED;
      var STATE_CANCELLED = 16;
      var STATE_FAILED = 32;
      function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId2();
        this.manager = null;
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
      }
      Recognizer.prototype = {
        /**
         * @virtual
         * @type {Object}
         */
        defaults: {},
        /**
         * set options
         * @param {Object} options
         * @return {Recognizer}
         */
        set: function(options) {
          assign(this.options, options);
          this.manager && this.manager.touchAction.update();
          return this;
        },
        /**
         * recognize simultaneous with an other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        recognizeWith: function(otherRecognizer) {
          if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) {
            return this;
          }
          var simultaneous = this.simultaneous;
          otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
          if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
          }
          return this;
        },
        /**
         * drop the simultaneous link. it doesnt remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        dropRecognizeWith: function(otherRecognizer) {
          if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) {
            return this;
          }
          otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
          delete this.simultaneous[otherRecognizer.id];
          return this;
        },
        /**
         * recognizer can only run when an other is failing
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        requireFailure: function(otherRecognizer) {
          if (invokeArrayArg(otherRecognizer, "requireFailure", this)) {
            return this;
          }
          var requireFail = this.requireFail;
          otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
          if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
          }
          return this;
        },
        /**
         * drop the requireFailure link. it does not remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        dropRequireFailure: function(otherRecognizer) {
          if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) {
            return this;
          }
          otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
          var index = inArray(this.requireFail, otherRecognizer);
          if (index > -1) {
            this.requireFail.splice(index, 1);
          }
          return this;
        },
        /**
         * has require failures boolean
         * @returns {boolean}
         */
        hasRequireFailures: function() {
          return this.requireFail.length > 0;
        },
        /**
         * if the recognizer can recognize simultaneous with an other recognizer
         * @param {Recognizer} otherRecognizer
         * @returns {Boolean}
         */
        canRecognizeWith: function(otherRecognizer) {
          return !!this.simultaneous[otherRecognizer.id];
        },
        /**
         * You should use `tryEmit` instead of `emit` directly to check
         * that all the needed recognizers has failed before emitting.
         * @param {Object} input
         */
        emit: function(input) {
          var self2 = this;
          var state = this.state;
          function emit(event) {
            self2.manager.emit(event, input);
          }
          if (state < STATE_ENDED) {
            emit(self2.options.event + stateStr(state));
          }
          emit(self2.options.event);
          if (input.additionalEvent) {
            emit(input.additionalEvent);
          }
          if (state >= STATE_ENDED) {
            emit(self2.options.event + stateStr(state));
          }
        },
        /**
         * Check that all the require failure recognizers has failed,
         * if true, it emits a gesture event,
         * otherwise, setup the state to FAILED.
         * @param {Object} input
         */
        tryEmit: function(input) {
          if (this.canEmit()) {
            return this.emit(input);
          }
          this.state = STATE_FAILED;
        },
        /**
         * can we emit?
         * @returns {boolean}
         */
        canEmit: function() {
          var i = 0;
          while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
              return false;
            }
            i++;
          }
          return true;
        },
        /**
         * update the recognizer
         * @param {Object} inputData
         */
        recognize: function(inputData) {
          var inputDataClone = assign({}, inputData);
          if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
          }
          if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
          }
          this.state = this.process(inputDataClone);
          if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
          }
        },
        /**
         * return the state of the recognizer
         * the actual recognizing happens in this method
         * @virtual
         * @param {Object} inputData
         * @returns {Const} STATE
         */
        process: function(inputData) {
        },
        // jshint ignore:line
        /**
         * return the preferred touch-action
         * @virtual
         * @returns {Array}
         */
        getTouchAction: function() {
        },
        /**
         * called when the gesture isn't allowed to recognize
         * like when another is being recognized or it is disabled
         * @virtual
         */
        reset: function() {
        }
      };
      function stateStr(state) {
        if (state & STATE_CANCELLED) {
          return "cancel";
        } else if (state & STATE_ENDED) {
          return "end";
        } else if (state & STATE_CHANGED) {
          return "move";
        } else if (state & STATE_BEGAN) {
          return "start";
        }
        return "";
      }
      function directionStr(direction) {
        if (direction == DIRECTION_DOWN) {
          return "down";
        } else if (direction == DIRECTION_UP) {
          return "up";
        } else if (direction == DIRECTION_LEFT) {
          return "left";
        } else if (direction == DIRECTION_RIGHT) {
          return "right";
        }
        return "";
      }
      function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) {
          return manager.get(otherRecognizer);
        }
        return otherRecognizer;
      }
      function AttrRecognizer() {
        Recognizer.apply(this, arguments);
      }
      inherit(AttrRecognizer, Recognizer, {
        /**
         * @namespace
         * @memberof AttrRecognizer
         */
        defaults: {
          /**
           * @type {Number}
           * @default 1
           */
          pointers: 1
        },
        /**
         * Used to check if it the recognizer receives valid input, like input.distance > 10.
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {Boolean} recognized
         */
        attrTest: function(input) {
          var optionPointers = this.options.pointers;
          return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
         * Process the input and return the state for the recognizer
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {*} State
         */
        process: function(input) {
          var state = this.state;
          var eventType = input.eventType;
          var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
          var isValid = this.attrTest(input);
          if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
          } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
              return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
              return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
          }
          return STATE_FAILED;
        }
      });
      function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
      }
      inherit(PanRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof PanRecognizer
         */
        defaults: {
          event: "pan",
          threshold: 10,
          pointers: 1,
          direction: DIRECTION_ALL
        },
        getTouchAction: function() {
          var direction = this.options.direction;
          var actions = [];
          if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
          }
          if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
          }
          return actions;
        },
        directionTest: function(input) {
          var options = this.options;
          var hasMoved = true;
          var distance = input.distance;
          var direction = input.direction;
          var x = input.deltaX;
          var y = input.deltaY;
          if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
              direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
              hasMoved = x != this.pX;
              distance = Math.abs(input.deltaX);
            } else {
              direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
              hasMoved = y != this.pY;
              distance = Math.abs(input.deltaY);
            }
          }
          input.direction = direction;
          return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
          return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
          this.pX = input.deltaX;
          this.pY = input.deltaY;
          var direction = directionStr(input.direction);
          if (direction) {
            input.additionalEvent = this.options.event + direction;
          }
          this._super.emit.call(this, input);
        }
      });
      function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
      }
      inherit(PinchRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof PinchRecognizer
         */
        defaults: {
          event: "pinch",
          threshold: 0,
          pointers: 2
        },
        getTouchAction: function() {
          return [TOUCH_ACTION_NONE];
        },
        attrTest: function(input) {
          return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
          if (input.scale !== 1) {
            var inOut = input.scale < 1 ? "in" : "out";
            input.additionalEvent = this.options.event + inOut;
          }
          this._super.emit.call(this, input);
        }
      });
      function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
      }
      inherit(PressRecognizer, Recognizer, {
        /**
         * @namespace
         * @memberof PressRecognizer
         */
        defaults: {
          event: "press",
          pointers: 1,
          time: 251,
          // minimal time of the pointer to be pressed
          threshold: 9
          // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
          return [TOUCH_ACTION_AUTO];
        },
        process: function(input) {
          var options = this.options;
          var validPointers = input.pointers.length === options.pointers;
          var validMovement = input.distance < options.threshold;
          var validTime = input.deltaTime > options.time;
          this._input = input;
          if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) {
            this.reset();
          } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(
              function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
              },
              options.time,
              this
            );
          } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
          }
          return STATE_FAILED;
        },
        reset: function() {
          clearTimeout(this._timer);
        },
        emit: function(input) {
          if (this.state !== STATE_RECOGNIZED) {
            return;
          }
          if (input && input.eventType & INPUT_END) {
            this.manager.emit(this.options.event + "up", input);
          } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
          }
        }
      });
      function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
      }
      inherit(RotateRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof RotateRecognizer
         */
        defaults: {
          event: "rotate",
          threshold: 0,
          pointers: 2
        },
        getTouchAction: function() {
          return [TOUCH_ACTION_NONE];
        },
        attrTest: function(input) {
          return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
      });
      function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
      }
      inherit(SwipeRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof SwipeRecognizer
         */
        defaults: {
          event: "swipe",
          threshold: 10,
          velocity: 0.3,
          direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
          pointers: 1
        },
        getTouchAction: function() {
          return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
          var direction = this.options.direction;
          var velocity;
          if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
          } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
          } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
          }
          return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
          var direction = directionStr(input.offsetDirection);
          if (direction) {
            this.manager.emit(this.options.event + direction, input);
          }
          this.manager.emit(this.options.event, input);
        }
      });
      function TapRecognizer() {
        Recognizer.apply(this, arguments);
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
      }
      inherit(TapRecognizer, Recognizer, {
        /**
         * @namespace
         * @memberof PinchRecognizer
         */
        defaults: {
          event: "tap",
          pointers: 1,
          taps: 1,
          interval: 300,
          // max time between the multi-tap taps
          time: 250,
          // max time of the pointer to be down (like finger on the screen)
          threshold: 9,
          // a minimal movement is ok, but keep it low
          posThreshold: 10
          // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
          return [TOUCH_ACTION_MANIPULATION];
        },
        process: function(input) {
          var options = this.options;
          var validPointers = input.pointers.length === options.pointers;
          var validMovement = input.distance < options.threshold;
          var validTouchTime = input.deltaTime < options.time;
          this.reset();
          if (input.eventType & INPUT_START && this.count === 0) {
            return this.failTimeout();
          }
          if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
              return this.failTimeout();
            }
            var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
            this.pTime = input.timeStamp;
            this.pCenter = input.center;
            if (!validMultiTap || !validInterval) {
              this.count = 1;
            } else {
              this.count += 1;
            }
            this._input = input;
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
              if (!this.hasRequireFailures()) {
                return STATE_RECOGNIZED;
              } else {
                this._timer = setTimeoutContext(
                  function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                  },
                  options.interval,
                  this
                );
                return STATE_BEGAN;
              }
            }
          }
          return STATE_FAILED;
        },
        failTimeout: function() {
          this._timer = setTimeoutContext(
            function() {
              this.state = STATE_FAILED;
            },
            this.options.interval,
            this
          );
          return STATE_FAILED;
        },
        reset: function() {
          clearTimeout(this._timer);
        },
        emit: function() {
          if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
          }
        }
      });
      function Hammer2(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(
          options.recognizers,
          Hammer2.defaults.preset
        );
        return new Manager(element, options);
      }
      Hammer2.VERSION = "2.0.7";
      Hammer2.defaults = {
        /**
         * set if DOM events are being triggered.
         * But this is slower and unused by simple implementations, so disabled by default.
         * @type {Boolean}
         * @default false
         */
        domEvents: false,
        /**
         * The value for the touchAction property/fallback.
         * When set to `compute` it will magically set the correct value based on the added recognizers.
         * @type {String}
         * @default compute
         */
        touchAction: TOUCH_ACTION_COMPUTE,
        /**
         * @type {Boolean}
         * @default true
         */
        enable: true,
        /**
         * EXPERIMENTAL FEATURE -- can be removed/changed
         * Change the parent input target element.
         * If Null, then it is being set the to main element.
         * @type {Null|EventTarget}
         * @default null
         */
        inputTarget: null,
        /**
         * force an input class
         * @type {Null|Function}
         * @default null
         */
        inputClass: null,
        /**
         * Default recognizer setup when calling `Hammer()`
         * When creating a new Manager these will be skipped.
         * @type {Array}
         */
        preset: [
          // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
          [RotateRecognizer, { enable: false }],
          [PinchRecognizer, { enable: false }, ["rotate"]],
          [SwipeRecognizer, { direction: DIRECTION_HORIZONTAL }],
          [PanRecognizer, { direction: DIRECTION_HORIZONTAL }, ["swipe"]],
          [TapRecognizer],
          [TapRecognizer, { event: "doubletap", taps: 2 }, ["tap"]],
          [PressRecognizer]
        ],
        /**
         * Some CSS properties can be used to improve the working of Hammer.
         * Add them to this method and they will be set when creating a new Manager.
         * @namespace
         */
        cssProps: {
          /**
           * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
           * @type {String}
           * @default 'none'
           */
          userSelect: "none",
          /**
           * Disable the Windows Phone grippers when pressing an element.
           * @type {String}
           * @default 'none'
           */
          touchSelect: "none",
          /**
           * Disables the default callout shown when you touch and hold a touch target.
           * On iOS, when you touch and hold a touch target such as a link, Safari displays
           * a callout containing information about the link. This property allows you to disable that callout.
           * @type {String}
           * @default 'none'
           */
          touchCallout: "none",
          /**
           * Specifies whether zooming is enabled. Used by IE10>
           * @type {String}
           * @default 'none'
           */
          contentZooming: "none",
          /**
           * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
           * @type {String}
           * @default 'none'
           */
          userDrag: "none",
          /**
           * Overrides the highlight color shown when the user taps a link or a JavaScript
           * clickable element in iOS. This property obeys the alpha value, if specified.
           * @type {String}
           * @default 'rgba(0,0,0,0)'
           */
          tapHighlightColor: "rgba(0,0,0,0)"
        }
      };
      var STOP = 1;
      var FORCED_STOP = 2;
      function Manager(element, options) {
        this.options = assign({}, Hammer2.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(
          this.options.recognizers,
          function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
          },
          this
        );
      }
      Manager.prototype = {
        /**
         * set options
         * @param {Object} options
         * @returns {Manager}
         */
        set: function(options) {
          assign(this.options, options);
          if (options.touchAction) {
            this.touchAction.update();
          }
          if (options.inputTarget) {
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
          }
          return this;
        },
        /**
         * stop recognizing for this session.
         * This session will be discarded, when a new [input]start event is fired.
         * When forced, the recognizer cycle is stopped immediately.
         * @param {Boolean} [force]
         */
        stop: function(force) {
          this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
         * run the recognizers!
         * called by the inputHandler function on every movement of the pointers (touches)
         * it walks through all the recognizers and tries to detect the gesture that is being made
         * @param {Object} inputData
         */
        recognize: function(inputData) {
          var session = this.session;
          if (session.stopped) {
            return;
          }
          this.touchAction.preventDefaults(inputData);
          var recognizer;
          var recognizers = this.recognizers;
          var curRecognizer = session.curRecognizer;
          if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
            curRecognizer = session.curRecognizer = null;
          }
          var i = 0;
          while (i < recognizers.length) {
            recognizer = recognizers[i];
            if (session.stopped !== FORCED_STOP && // 1
            (!curRecognizer || recognizer == curRecognizer || // 2
            recognizer.canRecognizeWith(curRecognizer))) {
              recognizer.recognize(inputData);
            } else {
              recognizer.reset();
            }
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
              curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
          }
        },
        /**
         * get a recognizer by its event name.
         * @param {Recognizer|String} recognizer
         * @returns {Recognizer|Null}
         */
        get: function(recognizer) {
          if (recognizer instanceof Recognizer) {
            return recognizer;
          }
          var recognizers = this.recognizers;
          for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
              return recognizers[i];
            }
          }
          return null;
        },
        /**
         * add a recognizer to the manager
         * existing recognizers with the same event name will be removed
         * @param {Recognizer} recognizer
         * @returns {Recognizer|Manager}
         */
        add: function(recognizer) {
          if (invokeArrayArg(recognizer, "add", this)) {
            return this;
          }
          var existing = this.get(recognizer.options.event);
          if (existing) {
            this.remove(existing);
          }
          this.recognizers.push(recognizer);
          recognizer.manager = this;
          this.touchAction.update();
          return recognizer;
        },
        /**
         * remove a recognizer by name or instance
         * @param {Recognizer|String} recognizer
         * @returns {Manager}
         */
        remove: function(recognizer) {
          if (invokeArrayArg(recognizer, "remove", this)) {
            return this;
          }
          recognizer = this.get(recognizer);
          if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);
            if (index !== -1) {
              recognizers.splice(index, 1);
              this.touchAction.update();
            }
          }
          return this;
        },
        /**
         * bind event
         * @param {String} events
         * @param {Function} handler
         * @returns {EventEmitter} this
         */
        on: function(events, handler) {
          if (events === undefined2) {
            return;
          }
          if (handler === undefined2) {
            return;
          }
          var handlers = this.handlers;
          each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
          });
          return this;
        },
        /**
         * unbind event, leave emit blank to remove all handlers
         * @param {String} events
         * @param {Function} [handler]
         * @returns {EventEmitter} this
         */
        off: function(events, handler) {
          if (events === undefined2) {
            return;
          }
          var handlers = this.handlers;
          each(splitStr(events), function(event) {
            if (!handler) {
              delete handlers[event];
            } else {
              handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
          });
          return this;
        },
        /**
         * emit event to the listeners
         * @param {String} event
         * @param {Object} data
         */
        emit: function(event, data) {
          if (this.options.domEvents) {
            triggerDomEvent(event, data);
          }
          var handlers = this.handlers[event] && this.handlers[event].slice();
          if (!handlers || !handlers.length) {
            return;
          }
          data.type = event;
          data.preventDefault = function() {
            data.srcEvent.preventDefault();
          };
          var i = 0;
          while (i < handlers.length) {
            handlers[i](data);
            i++;
          }
        },
        /**
         * destroy the manager and unbinds all events
         * it doesn't unbind dom events, that is the user own responsibility
         */
        destroy: function() {
          this.element && toggleCssProps(this, false);
          this.handlers = {};
          this.session = {};
          this.input.destroy();
          this.element = null;
        }
      };
      function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) {
          return;
        }
        var prop;
        each(manager.options.cssProps, function(value, name) {
          prop = prefixed(element.style, name);
          if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
          } else {
            element.style[prop] = manager.oldCssProps[prop] || "";
          }
        });
        if (!add) {
          manager.oldCssProps = {};
        }
      }
      function triggerDomEvent(event, data) {
        var gestureEvent = document2.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
      }
      assign(Hammer2, {
        INPUT_START,
        INPUT_MOVE,
        INPUT_END,
        INPUT_CANCEL,
        STATE_POSSIBLE,
        STATE_BEGAN,
        STATE_CHANGED,
        STATE_ENDED,
        STATE_RECOGNIZED,
        STATE_CANCELLED,
        STATE_FAILED,
        DIRECTION_NONE,
        DIRECTION_LEFT,
        DIRECTION_RIGHT,
        DIRECTION_UP,
        DIRECTION_DOWN,
        DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL,
        DIRECTION_ALL,
        Manager,
        Input,
        TouchAction,
        TouchInput,
        MouseInput,
        PointerEventInput,
        TouchMouseInput,
        SingleTouchInput,
        Recognizer,
        AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each,
        merge,
        extend,
        assign,
        inherit,
        bindFn,
        prefixed
      });
      var freeGlobal = typeof window2 !== "undefined" ? window2 : typeof self !== "undefined" ? self : {};
      freeGlobal.Hammer = Hammer2;
      if (typeof define === "function" && define.amd) {
        define(function() {
          return Hammer2;
        });
      } else if (typeof module != "undefined" && module.exports) {
        module.exports = Hammer2;
      } else {
        window2[exportName] = Hammer2;
      }
    })(window, document, "Hammer");
  }
});

// src/lib/touch-emulator.cjs
var require_touch_emulator = __commonJS({
  "src/lib/touch-emulator.cjs"(exports$1, module) {
    (function(window2, document2, exportName, undefined2) {
      var isMultiTouch = false;
      var multiTouchStartPos;
      var eventTarget;
      var touchElements = {};
      if (!document2.createTouch) {
        document2.createTouch = function(view, target, identifier, pageX, pageY, screenX, screenY, clientX, clientY) {
          if (clientX == undefined2 || clientY == undefined2) {
            clientX = pageX - window2.pageXOffset;
            clientY = pageY - window2.pageYOffset;
          }
          return new Touch(target, identifier, {
            pageX,
            pageY,
            screenX,
            screenY,
            clientX,
            clientY
          });
        };
      }
      if (!document2.createTouchList) {
        document2.createTouchList = function() {
          var touchList = new TouchList();
          for (var i = 0; i < arguments.length; i++) {
            touchList[i] = arguments[i];
          }
          touchList.length = arguments.length;
          return touchList;
        };
      }
      function Touch(target, identifier, pos, deltaX, deltaY) {
        deltaX = deltaX || 0;
        deltaY = deltaY || 0;
        this.identifier = identifier;
        this.target = target;
        this.clientX = pos.clientX + deltaX;
        this.clientY = pos.clientY + deltaY;
        this.screenX = pos.screenX + deltaX;
        this.screenY = pos.screenY + deltaY;
        this.pageX = pos.pageX + deltaX;
        this.pageY = pos.pageY + deltaY;
      }
      function TouchList() {
        var touchList = [];
        touchList.item = function(index) {
          return this[index] || null;
        };
        touchList.identifiedTouch = function(id) {
          return this[id + 1] || null;
        };
        return touchList;
      }
      function fakeTouchSupport() {
        var objs = [window2, document2.documentElement];
        var props = ["ontouchstart", "ontouchmove", "ontouchcancel", "ontouchend"];
        for (var o = 0; o < objs.length; o++) {
          for (var p = 0; p < props.length; p++) {
            if (objs[o] && objs[o][props[p]] == undefined2) {
              objs[o][props[p]] = null;
            }
          }
        }
      }
      function hasTouchSupport() {
        return "ontouchstart" in window2 || // touch events
        window2.Modernizr && window2.Modernizr.touch || // modernizr
        (navigator.msMaxTouchPoints || navigator.maxTouchPoints) > 2;
      }
      function preventMouseEvents(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      function onMouse(touchType) {
        return function(ev) {
          if (TouchEmulator2.ignoreTags.indexOf(ev.target.tagName) < 0) {
            preventMouseEvents(ev);
          }
          if (ev.which !== 1) {
            return;
          }
          if (ev.type == "mousedown" || !eventTarget || eventTarget && !eventTarget.dispatchEvent) {
            if (ev.composedPath() && ev.composedPath().length > 0) {
              eventTarget = ev.composedPath()[0];
            } else {
              eventTarget = ev.target;
            }
          }
          if (isMultiTouch && !ev.shiftKey) {
            triggerTouch("touchend", ev);
            isMultiTouch = false;
          }
          triggerTouch(touchType, ev);
          if (!isMultiTouch && ev.shiftKey) {
            isMultiTouch = true;
            multiTouchStartPos = {
              pageX: ev.pageX,
              pageY: ev.pageY,
              clientX: ev.clientX,
              clientY: ev.clientY,
              screenX: ev.screenX,
              screenY: ev.screenY
            };
            triggerTouch("touchstart", ev);
          }
          if (ev.type == "mouseup") {
            multiTouchStartPos = null;
            isMultiTouch = false;
            eventTarget = null;
          }
        };
      }
      function triggerTouch(eventName, mouseEv) {
        var touchEvent = document2.createEvent("Event");
        touchEvent.initEvent(eventName, true, true);
        touchEvent.altKey = mouseEv.altKey;
        touchEvent.ctrlKey = mouseEv.ctrlKey;
        touchEvent.metaKey = mouseEv.metaKey;
        touchEvent.shiftKey = mouseEv.shiftKey;
        touchEvent.touches = getActiveTouches(mouseEv, eventName);
        touchEvent.targetTouches = getActiveTouches(mouseEv, eventName);
        touchEvent.changedTouches = getChangedTouches(mouseEv, eventName);
        eventTarget.dispatchEvent(touchEvent);
      }
      function createTouchList(mouseEv) {
        var touchList = new TouchList();
        if (isMultiTouch) {
          var f = TouchEmulator2.multiTouchOffset;
          var deltaX = multiTouchStartPos.pageX - mouseEv.pageX;
          var deltaY = multiTouchStartPos.pageY - mouseEv.pageY;
          touchList.push(new Touch(eventTarget, 1, multiTouchStartPos, deltaX * -1 - f, deltaY * -1 + f));
          touchList.push(new Touch(eventTarget, 2, multiTouchStartPos, deltaX + f, deltaY - f));
        } else {
          touchList.push(new Touch(eventTarget, 1, mouseEv, 0, 0));
        }
        return touchList;
      }
      function getActiveTouches(mouseEv, eventName) {
        if (mouseEv.type == "mouseup") {
          return new TouchList();
        }
        var touchList = createTouchList(mouseEv);
        if (isMultiTouch && mouseEv.type != "mouseup" && eventName == "touchend") {
          touchList.splice(1, 1);
        }
        return touchList;
      }
      function getChangedTouches(mouseEv, eventName) {
        var touchList = createTouchList(mouseEv);
        if (isMultiTouch && mouseEv.type != "mouseup" && (eventName == "touchstart" || eventName == "touchend")) {
          touchList.splice(0, 1);
        }
        return touchList;
      }
      function showTouches(ev) {
        var touch, i, el, styles;
        for (i = 0; i < ev.touches.length; i++) {
          touch = ev.touches[i];
          el = touchElements[touch.identifier];
          if (!el) {
            el = touchElements[touch.identifier] = document2.createElement("div");
            document2.body.appendChild(el);
          }
          styles = TouchEmulator2.template(touch);
          for (var prop in styles) {
            el.style[prop] = styles[prop];
          }
        }
        if (ev.type == "touchend" || ev.type == "touchcancel") {
          for (i = 0; i < ev.changedTouches.length; i++) {
            touch = ev.changedTouches[i];
            el = touchElements[touch.identifier];
            if (el) {
              el.parentNode.removeChild(el);
              delete touchElements[touch.identifier];
            }
          }
        }
      }
      function TouchEmulator2() {
        if (hasTouchSupport()) {
          return;
        }
        fakeTouchSupport();
        window2.addEventListener("mousedown", onMouse("touchstart"), true);
        window2.addEventListener("mousemove", onMouse("touchmove"), true);
        window2.addEventListener("mouseup", onMouse("touchend"), true);
        window2.addEventListener("mouseenter", preventMouseEvents, true);
        window2.addEventListener("mouseleave", preventMouseEvents, true);
        window2.addEventListener("mouseout", preventMouseEvents, true);
        window2.addEventListener("mouseover", preventMouseEvents, true);
        window2.addEventListener("touchstart", showTouches, true);
        window2.addEventListener("touchmove", showTouches, true);
        window2.addEventListener("touchend", showTouches, true);
        window2.addEventListener("touchcancel", showTouches, true);
      }
      TouchEmulator2.multiTouchOffset = 75;
      TouchEmulator2.ignoreTags = ["TEXTAREA", "INPUT", "SELECT"];
      TouchEmulator2.template = function(touch) {
        var size = 30;
        var transform = "translate(" + (touch.clientX - size / 2) + "px, " + (touch.clientY - size / 2) + "px)";
        return {
          position: "fixed",
          left: 0,
          top: 0,
          background: "#fff",
          border: "solid 1px #999",
          opacity: 0.6,
          borderRadius: "100%",
          height: size + "px",
          width: size + "px",
          padding: 0,
          margin: 0,
          display: "block",
          overflow: "hidden",
          pointerEvents: "none",
          webkitUserSelect: "none",
          mozUserSelect: "none",
          userSelect: "none",
          webkitTransform: transform,
          mozTransform: transform,
          transform,
          zIndex: 100
        };
      };
      if (typeof define == "function" && define.amd) {
        define(function() {
          return TouchEmulator2;
        });
      } else if (typeof module != "undefined" && module.exports) {
        module.exports = TouchEmulator2;
      } else {
        window2[exportName] = TouchEmulator2;
      }
    })(window, document, "TouchEmulator");
  }
});
var CameraContext = createContext(null);
function CameraProvider({ wasm, children }) {
  const [scale, setScaleState] = useState(1);
  const [stagePos, setStagePosState] = useState({ x: 0, y: 0 });
  const wasmSyncTimeoutRef = useRef();
  const syncToWASM = useCallback(
    (_newScale, _newPos) => {
      if (!wasm) return;
      if (wasmSyncTimeoutRef.current) {
        clearTimeout(wasmSyncTimeoutRef.current);
      }
      wasmSyncTimeoutRef.current = setTimeout(() => {
      }, 150);
    },
    [wasm]
  );
  const setScale = useCallback((newScale) => {
    setScaleState(newScale);
    syncToWASM(newScale, stagePos);
  }, [stagePos, syncToWASM]);
  const setStagePos = useCallback((newPos) => {
    setStagePosState(typeof newPos === "function" ? newPos(stagePos) : newPos);
    syncToWASM(scale, typeof newPos === "function" ? newPos(stagePos) : newPos);
  }, [scale, syncToWASM]);
  const zoom = useCallback(
    (factor, centerX = 0, centerY = 0) => {
      const newScale = Math.max(0.1, Math.min(10, scale * factor));
      const mousePointTo = {
        x: (centerX - stagePos.x) / scale,
        y: (centerY - stagePos.y) / scale
      };
      const newPos = {
        x: centerX - mousePointTo.x * newScale,
        y: centerY - mousePointTo.y * newScale
      };
      setScaleState(newScale);
      setStagePosState(newPos);
      syncToWASM(newScale, newPos);
    },
    [scale, stagePos, syncToWASM]
  );
  const zoomTo = useCallback(
    (newScale, centerX = 0, centerY = 0) => {
      const clampedScale = Math.max(0.1, Math.min(10, newScale));
      const mousePointTo = {
        x: (centerX - stagePos.x) / scale,
        y: (centerY - stagePos.y) / scale
      };
      const newPos = {
        x: centerX - mousePointTo.x * clampedScale,
        y: centerY - mousePointTo.y * clampedScale
      };
      setScaleState(clampedScale);
      setStagePosState(newPos);
      syncToWASM(clampedScale, newPos);
    },
    [scale, stagePos, syncToWASM]
  );
  const pan = useCallback(
    (dx, dy) => {
      const newPos = {
        x: stagePos.x + dx,
        y: stagePos.y + dy
      };
      setStagePosState(newPos);
      syncToWASM(scale, newPos);
    },
    [stagePos, scale, syncToWASM]
  );
  const resetView = useCallback(() => {
    setScaleState(1);
    setStagePosState({ x: 0, y: 0 });
    syncToWASM(1, { x: 0, y: 0 });
  }, [syncToWASM]);
  const animateToPosition = useCallback(
    (targetX, targetY, targetScale = scale, duration = 500) => {
      const startScale = scale;
      const startPos = { ...stagePos };
      const startTime = Date.now();
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
        const currentScale = startScale + (targetScale - startScale) * eased;
        const currentPos = {
          x: startPos.x + (targetX - startPos.x) * eased,
          y: startPos.y + (targetY - startPos.y) * eased
        };
        setScaleState(currentScale);
        setStagePosState(currentPos);
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          syncToWASM(targetScale, { x: targetX, y: targetY });
        }
      };
      animate();
    },
    [scale, stagePos, syncToWASM]
  );
  const zoomToFit = useCallback(
    (bounds, padding = 100, duration = 500) => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const scaleX = (viewportWidth - padding * 2) / bounds.width;
      const scaleY = (viewportHeight - padding * 2) / bounds.height;
      const targetScale = Math.min(scaleX, scaleY, 10);
      const targetX = viewportWidth / 2 - (bounds.x + bounds.width / 2) * targetScale;
      const targetY = viewportHeight / 2 - (bounds.y + bounds.height / 2) * targetScale;
      animateToPosition(targetX, targetY, targetScale, duration);
    },
    [animateToPosition]
  );
  const controls = {
    scale,
    stagePos,
    setScale,
    setStagePos,
    zoom,
    zoomTo,
    pan,
    resetView,
    animateToPosition,
    zoomToFit
  };
  return /* @__PURE__ */ jsx(CameraContext.Provider, { value: controls, children });
}
function useCamera() {
  const context = useContext(CameraContext);
  if (!context) {
    throw new Error("useCamera must be used within CameraProvider");
  }
  return context;
}
var CloudGridContext = createContext(null);
function useCloudGrid() {
  const editor = useContext(CloudGridContext);
  if (!editor) {
    throw new Error("useCloudGrid must be used within a CloudGrid component");
  }
  return editor;
}
function useCloudGridOptional() {
  return useContext(CloudGridContext);
}

// ../../node_modules/clsx/dist/clsx.mjs
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

// ../../node_modules/tailwind-merge/dist/bundle-mjs.mjs
var concatArrays = (array1, array2) => {
  const combinedArray = new Array(array1.length + array2.length);
  for (let i = 0; i < array1.length; i++) {
    combinedArray[i] = array1[i];
  }
  for (let i = 0; i < array2.length; i++) {
    combinedArray[array1.length + i] = array2[i];
  }
  return combinedArray;
};
var createClassValidatorObject = (classGroupId, validator) => ({
  classGroupId,
  validator
});
var createClassPartObject = (nextPart = /* @__PURE__ */ new Map(), validators = null, classGroupId) => ({
  nextPart,
  validators,
  classGroupId
});
var CLASS_PART_SEPARATOR = "-";
var EMPTY_CONFLICTS = [];
var ARBITRARY_PROPERTY_PREFIX = "arbitrary..";
var createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    if (className.startsWith("[") && className.endsWith("]")) {
      return getGroupIdForArbitraryProperty(className);
    }
    const classParts = className.split(CLASS_PART_SEPARATOR);
    const startIndex = classParts[0] === "" && classParts.length > 1 ? 1 : 0;
    return getGroupRecursive(classParts, startIndex, classMap);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    if (hasPostfixModifier) {
      const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
      const baseConflicts = conflictingClassGroups[classGroupId];
      if (modifierConflicts) {
        if (baseConflicts) {
          return concatArrays(baseConflicts, modifierConflicts);
        }
        return modifierConflicts;
      }
      return baseConflicts || EMPTY_CONFLICTS;
    }
    return conflictingClassGroups[classGroupId] || EMPTY_CONFLICTS;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
var getGroupRecursive = (classParts, startIndex, classPartObject) => {
  const classPathsLength = classParts.length - startIndex;
  if (classPathsLength === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[startIndex];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  if (nextClassPartObject) {
    const result = getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
    if (result) return result;
  }
  const validators = classPartObject.validators;
  if (validators === null) {
    return void 0;
  }
  const classRest = startIndex === 0 ? classParts.join(CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join(CLASS_PART_SEPARATOR);
  const validatorsLength = validators.length;
  for (let i = 0; i < validatorsLength; i++) {
    const validatorObj = validators[i];
    if (validatorObj.validator(classRest)) {
      return validatorObj.classGroupId;
    }
  }
  return void 0;
};
var getGroupIdForArbitraryProperty = (className) => className.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const content = className.slice(1, -1);
  const colonIndex = content.indexOf(":");
  const property = content.slice(0, colonIndex);
  return property ? ARBITRARY_PROPERTY_PREFIX + property : void 0;
})();
var createClassMap = (config) => {
  const {
    theme,
    classGroups
  } = config;
  return processClassGroups(classGroups, theme);
};
var processClassGroups = (classGroups, theme) => {
  const classMap = createClassPartObject();
  for (const classGroupId in classGroups) {
    const group = classGroups[classGroupId];
    processClassesRecursively(group, classMap, classGroupId, theme);
  }
  return classMap;
};
var processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  const len = classGroup.length;
  for (let i = 0; i < len; i++) {
    const classDefinition = classGroup[i];
    processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
  }
};
var processClassDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  if (typeof classDefinition === "string") {
    processStringDefinition(classDefinition, classPartObject, classGroupId);
    return;
  }
  if (typeof classDefinition === "function") {
    processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
    return;
  }
  processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
var processStringDefinition = (classDefinition, classPartObject, classGroupId) => {
  const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
  classPartObjectToEdit.classGroupId = classGroupId;
};
var processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  if (isThemeGetter(classDefinition)) {
    processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
    return;
  }
  if (classPartObject.validators === null) {
    classPartObject.validators = [];
  }
  classPartObject.validators.push(createClassValidatorObject(classGroupId, classDefinition));
};
var processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme) => {
  const entries = Object.entries(classDefinition);
  const len = entries.length;
  for (let i = 0; i < len; i++) {
    const [key, value] = entries[i];
    processClassesRecursively(value, getPart(classPartObject, key), classGroupId, theme);
  }
};
var getPart = (classPartObject, path) => {
  let current = classPartObject;
  const parts = path.split(CLASS_PART_SEPARATOR);
  const len = parts.length;
  for (let i = 0; i < len; i++) {
    const part = parts[i];
    let next = current.nextPart.get(part);
    if (!next) {
      next = createClassPartObject();
      current.nextPart.set(part, next);
    }
    current = next;
  }
  return current;
};
var isThemeGetter = (func) => "isThemeGetter" in func && func.isThemeGetter === true;
var createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ Object.create(null);
  let previousCache = /* @__PURE__ */ Object.create(null);
  const update = (key, value) => {
    cache[key] = value;
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ Object.create(null);
    }
  };
  return {
    get(key) {
      let value = cache[key];
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache[key]) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (key in cache) {
        cache[key] = value;
      } else {
        update(key, value);
      }
    }
  };
};
var IMPORTANT_MODIFIER = "!";
var MODIFIER_SEPARATOR = ":";
var EMPTY_MODIFIERS = [];
var createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal) => ({
  modifiers,
  hasImportantModifier,
  baseClassName,
  maybePostfixModifierPosition,
  isExternal
});
var createParseClassName = (config) => {
  const {
    prefix,
    experimentalParseClassName
  } = config;
  let parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let parenDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    const len = className.length;
    for (let index = 0; index < len; index++) {
      const currentCharacter = className[index];
      if (bracketDepth === 0 && parenDepth === 0) {
        if (currentCharacter === MODIFIER_SEPARATOR) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + 1;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") bracketDepth++;
      else if (currentCharacter === "]") bracketDepth--;
      else if (currentCharacter === "(") parenDepth++;
      else if (currentCharacter === ")") parenDepth--;
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
    let baseClassName = baseClassNameWithImportantModifier;
    let hasImportantModifier = false;
    if (baseClassNameWithImportantModifier.endsWith(IMPORTANT_MODIFIER)) {
      baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
      hasImportantModifier = true;
    } else if (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER)
    ) {
      baseClassName = baseClassNameWithImportantModifier.slice(1);
      hasImportantModifier = true;
    }
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
  };
  if (prefix) {
    const fullPrefix = prefix + MODIFIER_SEPARATOR;
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : createResultObject(EMPTY_MODIFIERS, false, className, void 0, true);
  }
  if (experimentalParseClassName) {
    const parseClassNameOriginal = parseClassName;
    parseClassName = (className) => experimentalParseClassName({
      className,
      parseClassName: parseClassNameOriginal
    });
  }
  return parseClassName;
};
var createSortModifiers = (config) => {
  const modifierWeights = /* @__PURE__ */ new Map();
  config.orderSensitiveModifiers.forEach((mod, index) => {
    modifierWeights.set(mod, 1e6 + index);
  });
  return (modifiers) => {
    const result = [];
    let currentSegment = [];
    for (let i = 0; i < modifiers.length; i++) {
      const modifier = modifiers[i];
      const isArbitrary = modifier[0] === "[";
      const isOrderSensitive = modifierWeights.has(modifier);
      if (isArbitrary || isOrderSensitive) {
        if (currentSegment.length > 0) {
          currentSegment.sort();
          result.push(...currentSegment);
          currentSegment = [];
        }
        result.push(modifier);
      } else {
        currentSegment.push(modifier);
      }
    }
    if (currentSegment.length > 0) {
      currentSegment.sort();
      result.push(...currentSegment);
    }
    return result;
  };
};
var createConfigUtils = (config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  sortModifiers: createSortModifiers(config),
  ...createClassGroupUtils(config)
});
var SPLIT_CLASSES_REGEX = /\s+/;
var mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds,
    sortModifiers
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      isExternal,
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    if (isExternal) {
      result = originalClassName + (result.length > 0 ? " " + result : result);
      continue;
    }
    let hasPostfixModifier = !!maybePostfixModifierPosition;
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = modifiers.length === 0 ? "" : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.indexOf(classId) > -1) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
var twJoin = (...classLists) => {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index < classLists.length) {
    if (argument = classLists[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
var toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
var createTailwindMerge = (createConfigFirst, ...createConfigRest) => {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall;
  const initTailwindMerge = (classList) => {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  };
  const tailwindMerge = (classList) => {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  };
  functionToCall = initTailwindMerge;
  return (...args) => functionToCall(twJoin(...args));
};
var fallbackThemeArr = [];
var fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || fallbackThemeArr;
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
var arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
var arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
var fractionRegex = /^\d+\/\d+$/;
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
var shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
var isFraction = (value) => fractionRegex.test(value);
var isNumber = (value) => !!value && !Number.isNaN(Number(value));
var isInteger = (value) => !!value && Number.isInteger(Number(value));
var isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
var isTshirtSize = (value) => tshirtUnitRegex.test(value);
var isAny = () => true;
var isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
var isNever = () => false;
var isShadow = (value) => shadowRegex.test(value);
var isImage = (value) => imageRegex.test(value);
var isAnyNonArbitrary = (value) => !isArbitraryValue(value) && !isArbitraryVariable(value);
var isArbitrarySize = (value) => getIsArbitraryValue(value, isLabelSize, isNever);
var isArbitraryValue = (value) => arbitraryValueRegex.test(value);
var isArbitraryLength = (value) => getIsArbitraryValue(value, isLabelLength, isLengthOnly);
var isArbitraryNumber = (value) => getIsArbitraryValue(value, isLabelNumber, isNumber);
var isArbitraryPosition = (value) => getIsArbitraryValue(value, isLabelPosition, isNever);
var isArbitraryImage = (value) => getIsArbitraryValue(value, isLabelImage, isImage);
var isArbitraryShadow = (value) => getIsArbitraryValue(value, isLabelShadow, isShadow);
var isArbitraryVariable = (value) => arbitraryVariableRegex.test(value);
var isArbitraryVariableLength = (value) => getIsArbitraryVariable(value, isLabelLength);
var isArbitraryVariableFamilyName = (value) => getIsArbitraryVariable(value, isLabelFamilyName);
var isArbitraryVariablePosition = (value) => getIsArbitraryVariable(value, isLabelPosition);
var isArbitraryVariableSize = (value) => getIsArbitraryVariable(value, isLabelSize);
var isArbitraryVariableImage = (value) => getIsArbitraryVariable(value, isLabelImage);
var isArbitraryVariableShadow = (value) => getIsArbitraryVariable(value, isLabelShadow, true);
var getIsArbitraryValue = (value, testLabel, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
var getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false) => {
  const result = arbitraryVariableRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return shouldMatchNoLabel;
  }
  return false;
};
var isLabelPosition = (label) => label === "position" || label === "percentage";
var isLabelImage = (label) => label === "image" || label === "url";
var isLabelSize = (label) => label === "length" || label === "size" || label === "bg-size";
var isLabelLength = (label) => label === "length";
var isLabelNumber = (label) => label === "number";
var isLabelFamilyName = (label) => label === "family-name";
var isLabelShadow = (label) => label === "shadow";
var getDefaultConfig = () => {
  const themeColor = fromTheme("color");
  const themeFont = fromTheme("font");
  const themeText = fromTheme("text");
  const themeFontWeight = fromTheme("font-weight");
  const themeTracking = fromTheme("tracking");
  const themeLeading = fromTheme("leading");
  const themeBreakpoint = fromTheme("breakpoint");
  const themeContainer = fromTheme("container");
  const themeSpacing = fromTheme("spacing");
  const themeRadius = fromTheme("radius");
  const themeShadow = fromTheme("shadow");
  const themeInsetShadow = fromTheme("inset-shadow");
  const themeTextShadow = fromTheme("text-shadow");
  const themeDropShadow = fromTheme("drop-shadow");
  const themeBlur = fromTheme("blur");
  const themePerspective = fromTheme("perspective");
  const themeAspect = fromTheme("aspect");
  const themeEase = fromTheme("ease");
  const themeAnimate = fromTheme("animate");
  const scaleBreak = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const scalePosition = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ];
  const scalePositionWithArbitrary = () => [...scalePosition(), isArbitraryVariable, isArbitraryValue];
  const scaleOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const scaleOverscroll = () => ["auto", "contain", "none"];
  const scaleUnambiguousSpacing = () => [isArbitraryVariable, isArbitraryValue, themeSpacing];
  const scaleInset = () => [isFraction, "full", "auto", ...scaleUnambiguousSpacing()];
  const scaleGridTemplateColsRows = () => [isInteger, "none", "subgrid", isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartAndEnd = () => ["auto", {
    span: ["full", isInteger, isArbitraryVariable, isArbitraryValue]
  }, isInteger, isArbitraryVariable, isArbitraryValue];
  const scaleGridColRowStartOrEnd = () => [isInteger, "auto", isArbitraryVariable, isArbitraryValue];
  const scaleGridAutoColsRows = () => ["auto", "min", "max", "fr", isArbitraryVariable, isArbitraryValue];
  const scaleAlignPrimaryAxis = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"];
  const scaleAlignSecondaryAxis = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"];
  const scaleMargin = () => ["auto", ...scaleUnambiguousSpacing()];
  const scaleSizing = () => [isFraction, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()];
  const scaleColor = () => [themeColor, isArbitraryVariable, isArbitraryValue];
  const scaleBgPosition = () => [...scalePosition(), isArbitraryVariablePosition, isArbitraryPosition, {
    position: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleBgRepeat = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }];
  const scaleBgSize = () => ["auto", "cover", "contain", isArbitraryVariableSize, isArbitrarySize, {
    size: [isArbitraryVariable, isArbitraryValue]
  }];
  const scaleGradientStopPosition = () => [isPercent, isArbitraryVariableLength, isArbitraryLength];
  const scaleRadius = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    themeRadius,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleBorderWidth = () => ["", isNumber, isArbitraryVariableLength, isArbitraryLength];
  const scaleLineStyle = () => ["solid", "dashed", "dotted", "double"];
  const scaleBlendMode = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const scaleMaskImagePosition = () => [isNumber, isPercent, isArbitraryVariablePosition, isArbitraryPosition];
  const scaleBlur = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    themeBlur,
    isArbitraryVariable,
    isArbitraryValue
  ];
  const scaleRotate = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleScale = () => ["none", isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleSkew = () => [isNumber, isArbitraryVariable, isArbitraryValue];
  const scaleTranslate = () => [isFraction, "full", ...scaleUnambiguousSpacing()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [isTshirtSize],
      breakpoint: [isTshirtSize],
      color: [isAny],
      container: [isTshirtSize],
      "drop-shadow": [isTshirtSize],
      ease: ["in", "out", "in-out"],
      font: [isAnyNonArbitrary],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [isTshirtSize],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [isTshirtSize],
      shadow: [isTshirtSize],
      spacing: ["px", isNumber],
      text: [isTshirtSize],
      "text-shadow": [isTshirtSize],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", isFraction, isArbitraryValue, isArbitraryVariable, themeAspect]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isNumber, isArbitraryValue, isArbitraryVariable, themeContainer]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": scaleBreak()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": scaleBreak()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: scalePositionWithArbitrary()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: scaleOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": scaleOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": scaleOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: scaleOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": scaleOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": scaleOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: scaleInset()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": scaleInset()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": scaleInset()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: scaleInset()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: scaleInset()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: scaleInset()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: scaleInset()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: scaleInset()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: scaleInset()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [isInteger, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [isFraction, "full", "auto", themeContainer, ...scaleUnambiguousSpacing()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [isNumber, isFraction, "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [isInteger, "first", "last", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": scaleGridAutoColsRows()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": scaleGridAutoColsRows()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: scaleUnambiguousSpacing()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": scaleUnambiguousSpacing()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": scaleUnambiguousSpacing()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...scaleAlignPrimaryAxis(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...scaleAlignSecondaryAxis(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...scaleAlignPrimaryAxis()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": scaleAlignPrimaryAxis()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: scaleUnambiguousSpacing()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: scaleUnambiguousSpacing()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: scaleUnambiguousSpacing()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: scaleMargin()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: scaleMargin()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: scaleMargin()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: scaleMargin()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: scaleMargin()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: scaleMargin()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: scaleMargin()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: scaleMargin()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: scaleMargin()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: scaleSizing()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [themeContainer, "screen", ...scaleSizing()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          themeContainer,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...scaleSizing()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          themeContainer,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [themeBreakpoint]
          },
          ...scaleSizing()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...scaleSizing()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...scaleSizing()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...scaleSizing()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", themeText, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [themeFontWeight, isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", isPercent, isArbitraryValue]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isArbitraryVariableFamilyName, isArbitraryValue, themeFont]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [themeTracking, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [isNumber, "none", isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          themeLeading,
          ...scaleUnambiguousSpacing()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: scaleColor()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: scaleColor()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...scaleLineStyle(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [isNumber, "from-font", "auto", isArbitraryVariable, isArbitraryLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: scaleColor()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [isNumber, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: scaleUnambiguousSpacing()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: scaleBgPosition()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: scaleBgRepeat()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: scaleBgSize()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, isInteger, isArbitraryVariable, isArbitraryValue],
          radial: ["", isArbitraryVariable, isArbitraryValue],
          conic: [isInteger, isArbitraryVariable, isArbitraryValue]
        }, isArbitraryVariableImage, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: scaleColor()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: scaleColor()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: scaleColor()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: scaleColor()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: scaleRadius()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": scaleRadius()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": scaleRadius()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": scaleRadius()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": scaleRadius()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": scaleRadius()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": scaleRadius()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": scaleRadius()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": scaleRadius()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": scaleRadius()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": scaleRadius()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": scaleRadius()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": scaleRadius()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": scaleRadius()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": scaleRadius()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: scaleBorderWidth()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": scaleBorderWidth()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": scaleBorderWidth()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": scaleBorderWidth()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": scaleBorderWidth()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": scaleBorderWidth()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": scaleBorderWidth()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": scaleBorderWidth()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": scaleBorderWidth()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": scaleBorderWidth()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": scaleBorderWidth()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: scaleColor()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": scaleColor()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": scaleColor()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": scaleColor()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": scaleColor()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": scaleColor()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": scaleColor()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": scaleColor()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": scaleColor()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: scaleColor()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...scaleLineStyle(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", isNumber, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: scaleColor()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: scaleColor()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", themeInsetShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": scaleColor()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: scaleBorderWidth()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: scaleColor()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [isNumber, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": scaleColor()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": scaleBorderWidth()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": scaleColor()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", themeTextShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": scaleColor()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...scaleBlendMode(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": scaleBlendMode()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [isNumber]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": scaleMaskImagePosition()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": scaleMaskImagePosition()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": scaleColor()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": scaleColor()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": scaleMaskImagePosition()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": scaleMaskImagePosition()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": scaleColor()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": scaleColor()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": scaleMaskImagePosition()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": scaleMaskImagePosition()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": scaleColor()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": scaleColor()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": scaleMaskImagePosition()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": scaleMaskImagePosition()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": scaleColor()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": scaleColor()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": scaleMaskImagePosition()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": scaleMaskImagePosition()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": scaleColor()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": scaleColor()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": scaleMaskImagePosition()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": scaleMaskImagePosition()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": scaleColor()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": scaleColor()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": scaleMaskImagePosition()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": scaleMaskImagePosition()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": scaleColor()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": scaleColor()
      }],
      "mask-image-radial": [{
        "mask-radial": [isArbitraryVariable, isArbitraryValue]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": scaleMaskImagePosition()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": scaleMaskImagePosition()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": scaleColor()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": scaleColor()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": scalePosition()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [isNumber]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": scaleMaskImagePosition()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": scaleMaskImagePosition()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": scaleColor()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": scaleColor()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: scaleBgPosition()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: scaleBgRepeat()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: scaleBgSize()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: scaleBlur()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeDropShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": scaleColor()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": scaleBlur()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": scaleUnambiguousSpacing()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [isNumber, "initial", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", themeEase, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", themeAnimate, isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [themePerspective, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": scalePositionWithArbitrary()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: scaleRotate()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": scaleRotate()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": scaleRotate()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": scaleRotate()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: scaleScale()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": scaleScale()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": scaleScale()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": scaleScale()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: scaleSkew()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": scaleSkew()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": scaleSkew()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [isArbitraryVariable, isArbitraryValue, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: scalePositionWithArbitrary()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: scaleTranslate()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": scaleTranslate()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": scaleTranslate()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": scaleTranslate()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: scaleColor()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: scaleColor()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryVariable, isArbitraryValue]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...scaleColor()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isNumber, isArbitraryVariableLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...scaleColor()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
};
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);

// src/lib/utils.ts
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// ../../node_modules/class-variance-authority/dist/index.mjs
var falsyToString = (value) => typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
var cx = clsx;
var cva = (base, config) => (props) => {
  var _config_compoundVariants;
  if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  const { variants, defaultVariants } = config;
  const getVariantClassNames = Object.keys(variants).map((variant) => {
    const variantProp = props === null || props === void 0 ? void 0 : props[variant];
    const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
    if (variantProp === null) return null;
    const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
    return variants[variant][variantKey];
  });
  const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
    let [key, value] = param;
    if (value === void 0) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param) => {
    let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
    return Object.entries(compoundVariantOptions).every((param2) => {
      let [key, value] = param2;
      return Array.isArray(value) ? value.includes({
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key]) : {
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key] === value;
    }) ? [
      ...acc,
      cvClass,
      cvClassName
    ] : acc;
  }, []);
  return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
};
var buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Button = React2.forwardRef(
  ({ className, variant, size, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: cn(buttonVariants({ variant, size, className })),
        ref,
        ...props
      }
    );
  }
);
Button.displayName = "Button";
var getPositionClasses = (position) => {
  const base = "absolute z-[100]";
  switch (position) {
    case "top-left":
      return cn(base, "top-4 left-4");
    case "top-center":
      return cn(base, "top-4 left-1/2 -translate-x-1/2");
    case "top-right":
      return cn(base, "top-4 right-4");
    case "bottom-left":
      return cn(base, "bottom-4 left-4");
    case "bottom-center":
      return cn(base, "bottom-4 left-1/2 -translate-x-1/2");
    case "bottom-right":
      return cn(base, "bottom-4 right-4");
    default:
      return cn(base, "top-4 left-4");
  }
};
function CompactToolbar({
  activeTool,
  onToolChange,
  position = "top-left"
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        getPositionClasses(position),
        "flex gap-2 p-2 bg-card/95 backdrop-blur-sm rounded-lg border border-border shadow-lg"
      ),
      children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: activeTool === "select" ? "default" : "ghost",
            size: "icon",
            onClick: () => onToolChange("select"),
            title: "Select Tool (V)",
            className: cn(
              "transition-all",
              activeTool === "select" && "scale-105 shadow-md"
            ),
            children: /* @__PURE__ */ jsx(Cursor, { size: 20, weight: "bold" })
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: activeTool === "pan" ? "default" : "ghost",
            size: "icon",
            onClick: () => onToolChange("pan"),
            title: "Pan Tool (H)",
            className: cn(
              "transition-all",
              activeTool === "pan" && "scale-105 shadow-md"
            ),
            children: /* @__PURE__ */ jsx(Hand, { size: 20, weight: "bold" })
          }
        )
      ]
    }
  );
}
var WasmContext = createContext(null);
function WasmProvider({ wasm, children }) {
  return /* @__PURE__ */ jsx(WasmContext.Provider, { value: wasm, children });
}
function useWasm() {
  return useContext(WasmContext);
}
function useWasmRequired() {
  const wasm = useContext(WasmContext);
  if (!wasm) {
    throw new Error("useWasmRequired must be used inside CloudGrid and WASM must be initialized");
  }
  return wasm;
}
var getPositionClasses2 = (position) => {
  const base = "absolute z-[100]";
  switch (position) {
    case "top-left":
      return cn(base, "top-4 left-4");
    case "top-center":
      return cn(base, "top-4 left-1/2 -translate-x-1/2");
    case "top-right":
      return cn(base, "top-4 right-4");
    case "bottom-left":
      return cn(base, "bottom-4 left-4");
    case "bottom-center":
      return cn(base, "bottom-4 left-1/2 -translate-x-1/2");
    case "bottom-right":
      return cn(base, "bottom-4 right-4");
    default:
      return cn(base, "top-4 right-4");
  }
};
function StatsPanel({ position = "top-right" }) {
  const wasm = useWasm();
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);
  const [objectCount, setObjectCount] = useState(0);
  const camera = useCamera();
  const zoom = Math.round(camera.scale * 100);
  useEffect(() => {
    if (!wasm) return;
    const updateState = () => {
      setCanUndo(wasm.canUndo());
      setCanRedo(wasm.canRedo());
      setObjectCount(wasm.getObjectCount());
    };
    updateState();
    const interval = setInterval(updateState, 100);
    return () => clearInterval(interval);
  }, [wasm]);
  if (!wasm) return null;
  const handleZoomIn = () => {
    camera.zoom(1.1, 0, 0);
  };
  const handleZoomOut = () => {
    camera.zoom(0.9, 0, 0);
  };
  const handleUndo = () => {
    if (canUndo) {
      wasm.undo();
      syncFromWasm(wasm);
      setCanUndo(wasm.canUndo());
      setCanRedo(wasm.canRedo());
    }
  };
  const handleRedo = () => {
    if (canRedo) {
      wasm.redo();
      syncFromWasm(wasm);
      setCanUndo(wasm.canUndo());
      setCanRedo(wasm.canRedo());
    }
  };
  const handleResetView = () => {
    camera.resetView();
  };
  const handleSortByColor = () => {
    window.dispatchEvent(new CustomEvent("sort-by-color"));
  };
  const handleAddMedia = () => {
    window.dispatchEvent(new CustomEvent("add-media"));
  };
  const handleDeleteSelected = () => {
    window.dispatchEvent(new CustomEvent("delete-selected"));
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        getPositionClasses2(position),
        "flex flex-col gap-2 p-2 bg-card/95 backdrop-blur-sm rounded-lg border border-border shadow-lg"
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex gap-1 items-center", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleUndo,
              disabled: !canUndo,
              title: "Undo (Ctrl+Z)",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(ArrowCounterClockwise, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleRedo,
              disabled: !canRedo,
              title: "Redo (Ctrl+Shift+Z)",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(ArrowClockwise, { size: 16, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "h-px bg-border" }),
        /* @__PURE__ */ jsxs("div", { className: "flex gap-1 items-center", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleZoomOut,
              title: "Zoom Out (-)",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(MagnifyingGlassMinus, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsxs("span", { className: "text-xs text-accent font-semibold min-w-[45px] text-center font-mono", children: [
            zoom,
            "%"
          ] }),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleZoomIn,
              title: "Zoom In (+)",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(MagnifyingGlassPlus, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleResetView,
              title: "Reset View",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(ArrowsOutSimple, { size: 16, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "h-px bg-border" }),
        /* @__PURE__ */ jsxs("div", { className: "flex gap-1 items-center", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleAddMedia,
              title: "Add Media",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(Plus, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleDeleteSelected,
              title: "Delete Selected",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(Trash, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "icon",
              onClick: handleSortByColor,
              title: "Sort by Color (RGB Gradient)",
              className: "h-8 w-8",
              children: /* @__PURE__ */ jsx(Palette, { size: 16, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "h-px bg-border" }),
        /* @__PURE__ */ jsxs("div", { className: "text-xs text-muted-foreground text-center", children: [
          /* @__PURE__ */ jsx("span", { className: "text-accent font-semibold font-mono", children: objectCount.toLocaleString() }),
          " ",
          "items"
        ] })
      ]
    }
  );
}
var globalCameraState = { zoom: 1, x: 0, y: 0 };
var listeners = /* @__PURE__ */ new Set();
function updateCameraState(wasm) {
  let newState;
  if ("getCameraZoom" in wasm) {
    newState = {
      zoom: wasm.getCameraZoom(),
      x: wasm.getCameraX(),
      y: wasm.getCameraY()
    };
  } else {
    newState = wasm;
  }
  if (newState.zoom !== globalCameraState.zoom || newState.x !== globalCameraState.x || newState.y !== globalCameraState.y) {
    globalCameraState = newState;
    listeners.forEach((listener) => listener(newState));
  }
}

// src/lib/grid-utils.ts
function snapToGrid(value, gridSize) {
  return Math.round(value / gridSize) * gridSize;
}
function getGroupSnapOffset(items, gridSize) {
  if (items.length === 0) return { dx: 0, dy: 0 };
  const minX = Math.min(...items.map((item) => item.x));
  const minY = Math.min(...items.map((item) => item.y));
  const snappedMinX = snapToGrid(minX, gridSize);
  const snappedMinY = snapToGrid(minY, gridSize);
  return {
    dx: snappedMinX - minX,
    dy: snappedMinY - minY
  };
}
function snapDimensionsToGrid(targetHeight, originalAspectRatio, gridSize) {
  const snappedHeight = snapToGrid(targetHeight, gridSize);
  const targetWidth = snappedHeight * originalAspectRatio;
  let bestWidth = snapToGrid(targetWidth, gridSize);
  let bestDiff = Math.abs(bestWidth / snappedHeight - originalAspectRatio);
  for (let offset = -5; offset <= 5; offset++) {
    if (offset === 0) continue;
    const testWidth = snapToGrid(targetWidth, gridSize) + offset * gridSize;
    if (testWidth <= 0) continue;
    const testAspectRatio = testWidth / snappedHeight;
    const diff = Math.abs(testAspectRatio - originalAspectRatio);
    if (diff < bestDiff) {
      bestDiff = diff;
      bestWidth = testWidth;
    }
  }
  return { width: bestWidth, height: snappedHeight };
}

// src/workers/createWorker.ts
function createGridWorker() {
  return new Worker(
    new URL("./grid.worker", import.meta.url),
    { type: "module" }
  );
}
function createImageLoaderWorker() {
  return new Worker(
    new URL("./image-loader.worker", import.meta.url),
    { type: "module" }
  );
}

// src/lib/imageLoading.ts
var LOD_LEVELS = {
  small: 150,
  // For thumbnails / zoomed out
  medium: 400,
  // For normal view
  full: 0
  // 0 = original resolution
};
var cachedBlobs = /* @__PURE__ */ new Set();
var loadingBlobs = /* @__PURE__ */ new Set();
var decodedBitmaps = /* @__PURE__ */ new Map();
var decodingImages = /* @__PURE__ */ new Map();
var imageWorker = null;
function getLODLevel(displayWidth, displayHeight) {
  const maxDim = Math.max(displayWidth, displayHeight);
  if (maxDim <= 150) return "small";
  if (maxDim <= 400) return "medium";
  return "full";
}
function getImageWorker() {
  if (!imageWorker) {
    imageWorker = createImageLoaderWorker();
    imageWorker.onmessage = (e) => {
      const { type, id, bitmap, requestedMaxDim, color } = e.data;
      if (type === "cached") {
        cachedBlobs.add(id);
        loadingBlobs.delete(id);
        if (color) {
          window.dispatchEvent(new CustomEvent("image-color-ready", { detail: { id, color } }));
        }
        window.dispatchEvent(new CustomEvent("blob-cached", { detail: { id } }));
      } else if (type === "decoded" && bitmap) {
        const level = decodingImages.get(id) || (requestedMaxDim === 150 ? "small" : requestedMaxDim === 400 ? "medium" : "full");
        decodingImages.delete(id);
        const existing = decodedBitmaps.get(id);
        if (existing) {
          try {
            existing.bitmap.close();
          } catch {
          }
        }
        decodedBitmaps.set(id, { bitmap, level });
        window.dispatchEvent(new CustomEvent("image-decoded", { detail: { id, level } }));
      } else if (type === "error") {
        loadingBlobs.delete(id);
        decodingImages.delete(id);
      }
    };
  }
  return imageWorker;
}
function requestBlobCache(src) {
  if (cachedBlobs.has(src) || loadingBlobs.has(src)) return;
  loadingBlobs.add(src);
  const worker = getImageWorker();
  worker.postMessage({ type: "load", id: src, src });
}
function requestDecode(src, level) {
  if (!cachedBlobs.has(src)) return;
  const currentlyDecoding = decodingImages.get(src);
  if (currentlyDecoding) {
    const levels = ["small", "medium", "full"];
    if (levels.indexOf(currentlyDecoding) >= levels.indexOf(level)) return;
  }
  decodingImages.set(src, level);
  const worker = getImageWorker();
  const maxDim = LOD_LEVELS[level];
  worker.postMessage({ type: "decode", id: src, maxDim });
}
function useImageOnDemand(src, displayWidth, displayHeight, isVisible) {
  const [, forceUpdate] = useState(0);
  const neededLevel = getLODLevel(displayWidth, displayHeight);
  useEffect(() => {
    requestBlobCache(src);
    const handleCached = (e) => {
      if (e.detail.id === src) {
        requestDecode(src, neededLevel);
      }
    };
    const handleDecoded = (e) => {
      if (e.detail.id === src) {
        forceUpdate((n) => n + 1);
      }
    };
    window.addEventListener("blob-cached", handleCached);
    window.addEventListener("image-decoded", handleDecoded);
    if (cachedBlobs.has(src)) {
      const existing = decodedBitmaps.get(src);
      if (!existing) {
        requestDecode(src, neededLevel);
      } else {
        const levels = ["small", "medium", "full"];
        const currentIdx = levels.indexOf(existing.level);
        const neededIdx = levels.indexOf(neededLevel);
        if (neededIdx > currentIdx && !decodingImages.has(src)) {
          requestDecode(src, neededLevel);
        }
      }
    }
    return () => {
      window.removeEventListener("blob-cached", handleCached);
      window.removeEventListener("image-decoded", handleDecoded);
    };
  }, [src, isVisible, neededLevel]);
  useEffect(() => {
  }, [src, isVisible]);
  const entry = decodedBitmaps.get(src);
  return entry?.bitmap ;
}
function CanvasImageNode({
  image,
  isSelected,
  onSelect,
  onDragStart,
  onDragMove,
  onDragEnd,
  activeTool,
  scale,
  isPinching,
  nodeRef
}) {
  const shapeRef = useRef(null);
  const displayWidth = image.width * scale;
  const displayHeight = image.height * scale;
  const bitmap = useImageOnDemand(image.src, displayWidth, displayHeight, true);
  useEffect(() => {
    if (nodeRef) nodeRef(shapeRef.current);
  }, [nodeRef, bitmap]);
  const handleClick = (e) => {
    if (activeTool === "select") {
      onSelect(e.evt.shiftKey);
    }
  };
  const handleDragStart = () => {
    onDragStart();
  };
  const handleDragMove = (e) => {
    const node = e.target;
    onDragMove(image.id, node.x(), node.y());
  };
  const handleDragEnd = (e) => {
    const node = e.target;
    onDragEnd(image.id, node.x(), node.y());
  };
  const isDraggable = activeTool === "select" && !isPinching;
  if (!bitmap) {
    return /* @__PURE__ */ jsx(
      Rect,
      {
        x: image.x,
        y: image.y,
        width: image.width,
        height: image.height,
        fill: "rgba(100, 100, 100, 0.3)",
        stroke: isSelected ? "#4ade80" : "rgba(150, 150, 150, 0.5)",
        strokeWidth: isSelected ? 2 : 1,
        draggable: isDraggable,
        onClick: handleClick,
        onDragStart: handleDragStart,
        onDragMove: handleDragMove,
        onDragEnd: handleDragEnd
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Image$1,
    {
      ref: shapeRef,
      id: image.id,
      image: bitmap,
      x: image.x,
      y: image.y,
      width: image.width,
      height: image.height,
      draggable: isDraggable,
      onClick: handleClick,
      onTap: () => onSelect(false),
      onDragStart: handleDragStart,
      onDragMove: handleDragMove,
      onDragEnd: handleDragEnd,
      stroke: isSelected ? "#4ade80" : void 0,
      strokeWidth: isSelected ? 2 / scale : 0
    }
  );
}

// src/components/constants.ts
var MIN_SIZE_MULTIPLIER = 2;
var MAX_SIZE_MULTIPLIER = 200;
function GridLayer({ width, height, gridSize, stageX, stageY, scale }) {
  const [gridBitmap, setGridBitmap] = useState(null);
  const workerRef = useRef(null);
  const pendingRef = useRef(false);
  const lastParamsRef = useRef({ width: 0, height: 0, gridSize: 0, stageX: 0, stageY: 0, scale: 1 });
  const throttledParams = useMemo(
    () => {
      return {
        width,
        height,
        gridSize,
        stageX: Math.round(stageX / 5) * 5,
        stageY: Math.round(stageY / 5) * 5,
        scale: Math.round(scale * 100) / 100
      };
    },
    [width, height, gridSize, Math.round(stageX / 5), Math.round(stageY / 5), Math.round(scale * 100)]
  );
  useEffect(() => {
    if (!workerRef.current) {
      workerRef.current = createGridWorker();
      workerRef.current.onmessage = (e) => {
        if (e.data.type === "rendered" && e.data.bitmap) {
          setGridBitmap(e.data.bitmap);
          pendingRef.current = false;
        }
      };
    }
    const last = lastParamsRef.current;
    if (last.width === throttledParams.width && last.height === throttledParams.height && last.gridSize === throttledParams.gridSize && last.stageX === throttledParams.stageX && last.stageY === throttledParams.stageY && last.scale === throttledParams.scale)
      return;
    lastParamsRef.current = { ...throttledParams };
    if (!workerRef.current) return;
    pendingRef.current = true;
    workerRef.current.postMessage({ type: "render", ...throttledParams });
  }, [throttledParams]);
  useEffect(
    () => () => {
      workerRef.current?.terminate();
    },
    []
  );
  if (!gridBitmap) return null;
  return /* @__PURE__ */ jsx(
    Image$1,
    {
      image: gridBitmap,
      x: -stageX / scale,
      y: -stageY / scale,
      width: width / scale,
      height: height / scale,
      listening: false
    }
  );
}

// src/lib/hammer.ts
var Hammer = require_hammer_konva();
var hammer_default = Hammer;

// src/lib/touch-emulator.ts
var TouchEmulator = require_touch_emulator();
var touch_emulator_default = TouchEmulator;
var Canvas = memo(function Canvas2({ wasm, activeTool, gridSize, onStatsUpdate }) {
  const containerRef = useRef(null);
  const stageRef = useRef(null);
  const transformerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 800, height: 600 });
  const [selectedIds, setSelectedIds] = useState([]);
  const camera = useCamera();
  const { scale, stagePos, setScale, setStagePos } = camera;
  const [selectionRect, setSelectionRect] = useState(null);
  const [isSelecting, setIsSelecting] = useState(false);
  const selectionStartRef = useRef(null);
  const lastFrameTime = useRef(0);
  const animationIdRef = useRef(0);
  const wasmInitializedRef = useRef(false);
  const imageNodesRef = useRef(/* @__PURE__ */ new Map());
  const activeToolRef = useRef(activeTool);
  const [isPinching, setIsPinching] = useState(false);
  const isPinchingRef = useRef(false);
  const { images, stateVersion } = useCanvasStore();
  const { moveObject, resizeObject, batchMoveObjects, batchResizeObjects, deleteObject, deleteObjects } = useCanvasActions(wasm);
  useEffect(() => {
    activeToolRef.current = activeTool;
  }, [activeTool]);
  useEffect(() => {
    isPinchingRef.current = isPinching;
  }, [isPinching]);
  useEffect(() => {
    setSelectedIds((prev) => {
      const existingIds = new Set(images.map((img) => img.id));
      return prev.filter((id) => existingIds.has(id));
    });
  }, [stateVersion, images]);
  useUndoRedoShortcuts(wasm, () => {
    setSelectedIds((prev) => {
      const existingIds = new Set(images.map((img) => img.id));
      return prev.filter((id) => existingIds.has(id));
    });
  });
  useEffect(() => {
    updateCameraState({ zoom: scale, x: stagePos.x, y: stagePos.y });
  }, [scale, stagePos]);
  const visibleImages = useMemo(() => {
    const padding = 200;
    const worldLeft = -stagePos.x / scale - padding;
    const worldTop = -stagePos.y / scale - padding;
    const worldRight = worldLeft + dimensions.width / scale + padding * 2;
    const worldBottom = worldTop + dimensions.height / scale + padding * 2;
    return images.filter((img) => {
      const imgRight = img.x + img.width;
      const imgBottom = img.y + img.height;
      return !(imgRight < worldLeft || img.x > worldRight || imgBottom < worldTop || img.y > worldBottom);
    });
  }, [images, stagePos.x, stagePos.y, scale, dimensions.width, dimensions.height]);
  useEffect(() => {
    if (!transformerRef.current) return;
    const nodes = [];
    selectedIds.forEach((id) => {
      const node = imageNodesRef.current.get(id);
      if (node) nodes.push(node);
    });
    transformerRef.current.nodes(nodes);
    transformerRef.current.getLayer()?.batchDraw();
  }, [selectedIds, visibleImages]);
  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setDimensions({ width: Math.floor(rect.width), height: Math.floor(rect.height) });
      }
    };
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  useEffect(() => {
    if (!wasm || wasmInitializedRef.current) return;
    wasmInitializedRef.current = true;
    syncFromWasm(wasm);
    getImageWorker();
  }, [wasm]);
  useEffect(() => {
    activeToolRef.current = activeTool;
  }, [activeTool]);
  useEffect(() => {
    const stage = stageRef.current;
    if (!stage) return;
    if (process.env.NODE_ENV === "development") {
      try {
        touch_emulator_default();
      } catch (e) {
        console.warn("TouchEmulator already initialized");
      }
    }
    Konva.hitOnDragEnabled = true;
    Konva.capturePointerEventsEnabled = true;
    const hammer = new hammer_default(stage, { domEvents: false });
    hammerRef.current = hammer;
    hammer.get("pinch").set({ enable: true });
    hammer.get("pan").set({ direction: hammer_default.DIRECTION_ALL, threshold: 0 });
    let panStartPos = null;
    hammer.on("panstart", (e) => {
      panStartPos = e.target?.attrs ? { x: e.target.attrs.x, y: e.target.attrs.y } : null;
    });
    hammer.on("pan", (e) => {
      if (activeToolRef.current !== "pan") return;
      if (!panStartPos) {
        panStartPos = e.target?.attrs ? { x: e.target.attrs.x, y: e.target.attrs.y } : null;
        return;
      }
      const delta = {
        x: isNaN(e.deltaX) ? 0 : e.deltaX,
        y: isNaN(e.deltaY) ? 0 : e.deltaY
      };
      setStagePos({
        x: panStartPos.x + delta.x,
        y: panStartPos.y + delta.y
      });
    });
    hammer.on("panend", () => {
      panStartPos = null;
    });
    let pinchStartScale = 1;
    let pinchStartPos = null;
    let pinchCenter = { x: 0, y: 0 };
    hammer.on("pinchstart", (e) => {
      setIsPinching(true);
      isPinchingRef.current = true;
      pinchStartScale = e.target.attrs.scaleX;
      pinchStartPos = { x: e.target.attrs.x, y: e.target.attrs.y };
      const stageBox = stage.container().getBoundingClientRect();
      pinchCenter = {
        x: e.center.x - stageBox.left,
        y: e.center.y - stageBox.top
      };
    });
    hammer.on("pinchmove", (e) => {
      if (!pinchStartPos) {
        pinchStartPos = e.target?.attrs ? { x: e.target.attrs.x, y: e.target.attrs.y } : null;
        return;
      }
      const newScale = Math.max(0.1, Math.min(10, pinchStartScale * e.scale));
      const mousePointTo = {
        x: (pinchCenter.x - pinchStartPos.x) / pinchStartScale,
        y: (pinchCenter.y - pinchStartPos.y) / pinchStartScale
      };
      setScale(newScale);
      setStagePos({
        x: pinchCenter.x - mousePointTo.x * newScale,
        y: pinchCenter.y - mousePointTo.y * newScale
      });
    });
    hammer.on("pinchend", () => {
      pinchStartPos = null;
      setIsPinching(false);
      isPinchingRef.current = false;
    });
    return () => {
      if (hammerRef.current) {
        hammerRef.current.destroy();
        hammerRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    const updateStats = (time) => {
      if (lastFrameTime.current) {
        const delta = time - lastFrameTime.current;
        const fps = Math.round(1e3 / delta);
        onStatsUpdate(visibleImages.length, images.length, fps);
      }
      lastFrameTime.current = time;
      animationIdRef.current = requestAnimationFrame(updateStats);
    };
    animationIdRef.current = requestAnimationFrame(updateStats);
    return () => cancelAnimationFrame(animationIdRef.current);
  }, [visibleImages.length, images.length, onStatsUpdate]);
  useEffect(() => {
    const handleColorReady = (e) => {
      const customEvent = e;
      const { id, color } = customEvent.detail;
      updateAssetColor(id, color);
    };
    window.addEventListener("image-color-ready", handleColorReady);
    return () => window.removeEventListener("image-color-ready", handleColorReady);
  }, []);
  const normalizeItemHeights = useCallback((itemIds, targetHeight) => {
    if (!wasm) return 0;
    const objectCount = wasm.getObjectCount();
    if (objectCount === 0) return 0;
    const idsToNormalize = itemIds || [];
    const normalizeAll = !itemIds || itemIds.length === 0;
    let avgHeight = targetHeight || 0;
    const itemData = [];
    if (avgHeight === 0) {
      let totalHeight = 0;
      let count = 0;
      for (let i = 0; i < objectCount; i++) {
        const id = wasm.getObjectIdAtIndex(i);
        if (wasm.objectExists(id)) {
          totalHeight += wasm.getObjectHeight(id);
          count++;
        }
      }
      avgHeight = count > 0 ? totalHeight / count : 350;
    }
    if (normalizeAll) {
      for (let i = 0; i < objectCount; i++) {
        const id = wasm.getObjectIdAtIndex(i);
        if (wasm.objectExists(id)) {
          itemData.push({
            id,
            width: wasm.getObjectWidth(id),
            height: wasm.getObjectHeight(id),
            x: wasm.getObjectX(id),
            y: wasm.getObjectY(id)
          });
        }
      }
    } else {
      idsToNormalize.forEach((id) => {
        if (wasm.objectExists(id)) {
          itemData.push({
            id,
            width: wasm.getObjectWidth(id),
            height: wasm.getObjectHeight(id),
            x: wasm.getObjectX(id),
            y: wasm.getObjectY(id)
          });
        }
      });
    }
    if (itemData.length === 0) return avgHeight;
    const resizes = [];
    itemData.forEach((item) => {
      const aspectRatio = item.width / item.height;
      const { width: newWidth, height: newHeight } = snapDimensionsToGrid(
        avgHeight,
        aspectRatio,
        gridSize
      );
      if (newWidth !== item.width || newHeight !== item.height) {
        resizes.push({
          id: item.id,
          oldX: item.x,
          oldY: item.y,
          oldWidth: item.width,
          oldHeight: item.height,
          newX: item.x,
          newY: item.y,
          newWidth,
          newHeight
        });
      }
    });
    if (resizes.length === 0) return avgHeight;
    const BATCH_SIZE = 100;
    try {
      for (let i = 0; i < resizes.length; i += BATCH_SIZE) {
        const batch = resizes.slice(i, i + BATCH_SIZE);
        wasm.beginBatchResize();
        batch.forEach((resize) => {
          wasm.addToBatchResize(
            resize.id,
            resize.oldX,
            resize.oldY,
            resize.oldWidth,
            resize.oldHeight,
            resize.newX,
            resize.newY,
            resize.newWidth,
            resize.newHeight
          );
        });
        wasm.endBatchResize();
      }
      syncFromWasm(wasm);
    } catch (error) {
      console.error("Failed to normalize item heights:", error);
      throw error;
    }
    return avgHeight;
  }, [wasm, gridSize]);
  const sortImagesByColor = useCallback(() => {
    if (!wasm) {
      return;
    }
    const imagesToSort = selectedIds.length > 0 ? images.filter((img) => selectedIds.includes(img.id)) : images;
    if (imagesToSort.length === 0) {
      console.warn("No images to sort");
      return;
    }
    const imagesWithColor = imagesToSort.filter((img) => {
      const numericId = getNumericId(img.id);
      if (!numericId) return false;
      const assetStringId = getAssetStringId(numericId);
      if (!assetStringId) return false;
      const metadata = getAssetMetadata(assetStringId);
      return metadata?.colorScore !== void 0;
    });
    if (imagesWithColor.length === 0) {
      console.warn("No color data available for images. Please wait for images to load.");
      return;
    }
    if (imagesWithColor.length < imagesToSort.length) {
      console.warn(
        `Color data available for ${imagesWithColor.length}/${imagesToSort.length} images. Sorting ${imagesWithColor.length} images.`
      );
    }
    const itemIds = imagesWithColor.map((img) => getNumericId(img.id)).filter((id) => id !== null && id !== 0);
    let avgHeight = 0;
    try {
      avgHeight = normalizeItemHeights(itemIds);
      if (avgHeight === 0) return;
    } catch (error) {
      console.error("Failed to normalize heights during color sort:", error);
      return;
    }
    const imageScores = [];
    imagesWithColor.forEach((img, idx) => {
      const numericId = getNumericId(img.id);
      if (!numericId) return;
      const assetStringId = getAssetStringId(numericId);
      if (!assetStringId) return;
      const metadata = getAssetMetadata(assetStringId);
      if (metadata?.colorScore !== void 0) {
        imageScores.push({
          id: img.id,
          src: img.src,
          score: metadata.colorScore,
          originalIdx: idx,
          assetId: assetStringId,
          width: img.width,
          height: img.height
        });
      }
    });
    imageScores.sort((a, b) => b.score - a.score);
    const normalizedHeight = snapToGrid(avgHeight, gridSize);
    const GAP = snapToGrid(50, gridSize);
    let startY = 0;
    let startX = 0;
    if (selectedIds.length > 0) {
      let maxBottomY = -Infinity;
      for (let i = 0; i < wasm.getObjectCount(); i++) {
        const id = wasm.getObjectIdAtIndex(i);
        if (wasm.objectExists(id)) {
          const y = wasm.getObjectY(id);
          const height = wasm.getObjectHeight(id);
          maxBottomY = Math.max(maxBottomY, y + height);
        }
      }
      startY = snapToGrid(maxBottomY + GAP * 2, gridSize);
      startX = 0;
    } else {
      startX = 0;
      startY = 0;
    }
    const MAX_ROW_WIDTH = 8e3;
    const rows = [];
    let currentRow = [];
    let currentRowWidth = 0;
    imageScores.forEach((imgScore) => {
      const numericId = getNumericId(imgScore.id);
      if (!numericId) return;
      const currentWidth = wasm.getObjectWidth(numericId);
      const currentHeight = wasm.getObjectHeight(numericId);
      const aspectRatio = currentWidth / currentHeight;
      const newWidth = snapToGrid(normalizedHeight * aspectRatio, gridSize);
      if (currentRow.length > 0 && currentRowWidth + GAP + newWidth > MAX_ROW_WIDTH) {
        rows.push(currentRow);
        currentRow = [];
        currentRowWidth = 0;
      }
      currentRow.push({
        id: imgScore.id,
        numericId,
        width: newWidth,
        height: normalizedHeight,
        x: 0,
        // Will be calculated below
        y: 0
        // Will be calculated below
      });
      currentRowWidth += (currentRow.length > 1 ? GAP : 0) + newWidth;
    });
    if (currentRow.length > 0) {
      rows.push(currentRow);
    }
    const moves = [];
    let currentY = startY;
    rows.forEach((row) => {
      const rowWidth = row.reduce((sum, item, idx) => sum + item.width + (idx > 0 ? GAP : 0), 0);
      const rowStartX = snapToGrid(startX - rowWidth / 2, gridSize);
      let currentX = rowStartX;
      row.forEach((item) => {
        item.x = currentX;
        item.y = currentY;
        moves.push({
          id: item.id,
          numericId: item.numericId,
          newX: item.x,
          newY: item.y,
          newWidth: item.width,
          newHeight: item.height
        });
        currentX += item.width + GAP;
      });
      currentY += normalizedHeight + GAP;
    });
    const baseDuration = 1;
    const maxDuration = 3;
    const threshold = 1e3;
    const scaledDuration = Math.min(
      baseDuration + imageScores.length / threshold * 1,
      maxDuration
    );
    moves.forEach((move) => {
      wasm.resizeObject(move.numericId, move.newX, move.newY, move.newWidth, move.newHeight);
    });
    moves.forEach((move) => {
      const node = imageNodesRef.current.get(move.id);
      if (node) {
        const currentX = node.x();
        const currentY2 = node.y();
        const currentWidth = node.width();
        const currentHeight = node.height();
        if (currentX !== move.newX || currentY2 !== move.newY || currentWidth !== move.newWidth || currentHeight !== move.newHeight) {
          node.to({
            x: move.newX,
            y: move.newY,
            width: move.newWidth,
            height: move.newHeight,
            duration: scaledDuration,
            easing: Konva.Easings.EaseInOut
          });
        }
      }
    });
    setTimeout(() => {
      syncFromWasm(wasm);
    }, scaledDuration * 1e3 + 100);
  }, [wasm, images, selectedIds, gridSize, normalizeItemHeights]);
  useEffect(() => {
    const handleSortByColor = () => {
      sortImagesByColor();
    };
    window.addEventListener("sort-by-color", handleSortByColor);
    return () => window.removeEventListener("sort-by-color", handleSortByColor);
  }, [sortImagesByColor]);
  const fileInputRef = useRef(null);
  const handleFileUpload = useCallback(async (files) => {
    if (!wasm || !files || files.length === 0) return;
    const objectCount = wasm.getObjectCount();
    let totalHeight = 0;
    let maxBottomY = 0;
    for (let i = 0; i < objectCount; i++) {
      const id = wasm.getObjectIdAtIndex(i);
      if (wasm.objectExists(id)) {
        const height = wasm.getObjectHeight(id);
        const y = wasm.getObjectY(id);
        const bottom = y + height;
        totalHeight += height;
        if (bottom > maxBottomY) {
          maxBottomY = bottom;
        }
      }
    }
    const avgHeight = objectCount > 0 ? totalHeight / objectCount : 350;
    const targetHeight = avgHeight;
    const GAP = snapToGrid(50, gridSize);
    const startY = snapToGrid(maxBottomY + GAP, gridSize);
    const newAssets = [];
    for (const file of Array.from(files)) {
      if (!file.type.match(/^image\/(png|jpeg|jpg)$/)) {
        console.warn("Skipping non-image file:", file.name);
        continue;
      }
      const src = URL.createObjectURL(file);
      try {
        const img = new Image();
        await new Promise((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = reject;
          img.src = src;
        });
        const originalWidth = img.width;
        const originalHeight = img.height;
        const aspectRatio = originalWidth / originalHeight;
        const { width, height } = snapDimensionsToGrid(
          targetHeight,
          aspectRatio,
          gridSize
        );
        const asset = {
          id: generateAssetId(),
          type: "image",
          x: 0,
          // Will be calculated after we know total width
          y: startY,
          w: width,
          // Display width
          h: height,
          // Display height
          src,
          alt: file.name,
          // Metadata: ONLY intrinsic properties from the source file
          metadata: {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            originalWidth,
            // Original dimensions from file
            originalHeight,
            uploadedAt: (/* @__PURE__ */ new Date()).toISOString()
          }
        };
        newAssets.push(asset);
      } catch (error) {
        console.warn("Failed to load image:", file.name, error);
        URL.revokeObjectURL(src);
      }
    }
    if (newAssets.length === 0) return;
    const totalWidth = newAssets.reduce((sum, asset) => sum + asset.w, 0) + GAP * (newAssets.length - 1);
    const centerX = 0;
    let currentX = snapToGrid(centerX - totalWidth / 2, gridSize);
    newAssets.forEach((asset) => {
      asset.x = currentX;
      currentX += asset.w + GAP;
    });
    const newItemIds = [];
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    newAssets.forEach((asset) => {
      const numericAssetId = registerAsset(asset.src, asset.id);
      if (asset.metadata) {
        setAssetMetadata(asset.id, asset.metadata, asset.src);
      }
      const numericId = wasm.addObject(asset.x, asset.y, asset.w, asset.h, numericAssetId, 1);
      const stringId = `img-${numericId}`;
      newItemIds.push(stringId);
      minX = Math.min(minX, asset.x);
      minY = Math.min(minY, asset.y);
      maxX = Math.max(maxX, asset.x + asset.w);
      maxY = Math.max(maxY, asset.y + asset.h);
    });
    syncFromWasm(wasm);
    if (newItemIds.length > 0 && objectCount > newItemIds.length) {
      const newNumericIds = newItemIds.map((id) => getNumericId(id)).filter((id) => id !== null);
      let existingTotalHeight = 0;
      let existingCount = 0;
      for (let i = 0; i < objectCount; i++) {
        const id = wasm.getObjectIdAtIndex(i);
        if (wasm.objectExists(id) && !newNumericIds.includes(id)) {
          existingTotalHeight += wasm.getObjectHeight(id);
          existingCount++;
        }
      }
      const existingAvgHeight = existingCount > 0 ? existingTotalHeight / existingCount : targetHeight;
      normalizeItemHeights(newNumericIds, existingAvgHeight);
    }
    minX = Infinity;
    minY = Infinity;
    maxX = -Infinity;
    maxY = -Infinity;
    newItemIds.forEach((stringId) => {
      const numericId = getNumericId(stringId);
      if (numericId !== null && wasm.objectExists(numericId)) {
        const x = wasm.getObjectX(numericId);
        const y = wasm.getObjectY(numericId);
        const width = wasm.getObjectWidth(numericId);
        const height = wasm.getObjectHeight(numericId);
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x + width);
        maxY = Math.max(maxY, y + height);
      }
    });
    if (newItemIds.length > 0) {
      setSelectedIds(newItemIds);
      window.dispatchEvent(new CustomEvent("assets-added", {
        detail: { assets: newAssets }
      }));
      window.dispatchEvent(new CustomEvent("zoom-to-bounds", {
        detail: {
          x: minX,
          y: minY,
          width: maxX - minX,
          height: maxY - minY
        }
      }));
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [wasm, gridSize, normalizeItemHeights]);
  useEffect(() => {
    const handleAddMedia = () => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };
    window.addEventListener("add-media", handleAddMedia);
    return () => window.removeEventListener("add-media", handleAddMedia);
  }, []);
  useEffect(() => {
    const handleZoomToBounds = (e) => {
      const customEvent = e;
      if (customEvent.detail) {
        camera.zoomToFit(customEvent.detail, 100, 500);
      }
    };
    window.addEventListener("zoom-to-bounds", handleZoomToBounds);
    return () => window.removeEventListener("zoom-to-bounds", handleZoomToBounds);
  }, [camera]);
  useEffect(() => {
    const handleSelectItems = (e) => {
      const customEvent = e;
      if (customEvent.detail?.ids) {
        setSelectedIds(customEvent.detail.ids);
      }
    };
    window.addEventListener("select-items", handleSelectItems);
    return () => window.removeEventListener("select-items", handleSelectItems);
  }, []);
  useEffect(() => {
    const handleZoomToSelected = () => {
      if (!wasm || selectedIds.length === 0) return;
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      selectedIds.forEach((id) => {
        const numericId = getNumericId(id);
        if (numericId !== null && wasm.objectExists(numericId)) {
          const x = wasm.getObjectX(numericId);
          const y = wasm.getObjectY(numericId);
          const width = wasm.getObjectWidth(numericId);
          const height = wasm.getObjectHeight(numericId);
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x + width);
          maxY = Math.max(maxY, y + height);
        }
      });
      if (minX !== Infinity) {
        camera.zoomToFit({
          x: minX,
          y: minY,
          width: maxX - minX,
          height: maxY - minY
        }, 100, 500);
      }
    };
    window.addEventListener("zoom-to-selected", handleZoomToSelected);
    return () => window.removeEventListener("zoom-to-selected", handleZoomToSelected);
  }, [wasm, selectedIds, camera]);
  useEffect(() => {
    const handleDeleteSelected = () => {
      if (selectedIds.length === 0) return;
      const numericIds = selectedIds.map((id) => getNumericId(id)).filter((id) => id !== null);
      if (numericIds.length > 0) {
        deleteObjects(numericIds);
        setSelectedIds([]);
      }
    };
    window.addEventListener("delete-selected", handleDeleteSelected);
    return () => window.removeEventListener("delete-selected", handleDeleteSelected);
  }, [selectedIds, deleteObjects]);
  useEffect(() => {
    window.cloudGridAddImage = () => {
      if (!wasm) return;
      const seed = Math.floor(Math.random() * 1e3);
      const src = `https://picsum.photos/seed/${seed}/1920/1080`;
      const assetId = registerAsset(src);
      wasm.addObject(
        snapToGrid(Math.random() * 2e3 - 1e3, gridSize),
        snapToGrid(Math.random() * 2e3 - 1e3, gridSize),
        snapToGrid(300, gridSize),
        snapToGrid(200, gridSize),
        assetId,
        1
      );
      syncFromWasm(wasm);
    };
  }, [wasm, gridSize]);
  const handleImageSelect = useCallback((id, shiftKey) => {
    if (isPinchingRef.current) return;
    if (shiftKey) {
      setSelectedIds((prev) => prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]);
    } else {
      setSelectedIds([id]);
    }
  }, []);
  const dragInitialPositionsRef = useRef(null);
  const handleDragStart = useCallback(() => {
    if (isPinchingRef.current) return;
    const positions = /* @__PURE__ */ new Map();
    selectedIds.forEach((id) => {
      const img = images.find((i) => i.id === id);
      if (img) {
        positions.set(id, { x: img.x, y: img.y });
      }
    });
    dragInitialPositionsRef.current = positions;
  }, [selectedIds, images]);
  const handleDragMove = useCallback(
    (draggedId, newX, newY) => {
      if (isPinchingRef.current) return;
      if (!dragInitialPositionsRef.current || selectedIds.length <= 1) return;
      if (!selectedIds.includes(draggedId)) return;
      const initialPos = dragInitialPositionsRef.current.get(draggedId);
      if (!initialPos) return;
      const dx = newX - initialPos.x;
      const dy = newY - initialPos.y;
      selectedIds.forEach((id) => {
        if (id !== draggedId) {
          const node = imageNodesRef.current.get(id);
          const nodeInitialPos = dragInitialPositionsRef.current?.get(id);
          if (node && nodeInitialPos) {
            node.x(snapToGrid(nodeInitialPos.x + dx, gridSize));
            node.y(snapToGrid(nodeInitialPos.y + dy, gridSize));
          }
        }
      });
    },
    [selectedIds]
  );
  const handleDragEnd = useCallback(
    (draggedId, newX, newY) => {
      if (isPinchingRef.current) return;
      if (!wasm) return;
      if (selectedIds.length > 1 && !dragInitialPositionsRef.current) {
        return;
      }
      if (selectedIds.length <= 1) {
        const numericId = getNumericId(draggedId);
        const node = imageNodesRef.current.get(draggedId);
        if (node && numericId > 0) {
          node.x(snapToGrid(newX, gridSize));
          node.y(snapToGrid(newY, gridSize));
          moveObject(numericId, snapToGrid(newX, gridSize), snapToGrid(newY, gridSize));
        }
        dragInitialPositionsRef.current = null;
        return;
      }
      const draggedInitialPos = dragInitialPositionsRef.current.get(draggedId);
      if (!draggedInitialPos) {
        dragInitialPositionsRef.current = null;
        return;
      }
      const totalDx = newX - draggedInitialPos.x;
      const totalDy = newY - draggedInitialPos.y;
      const finalPositions = [];
      selectedIds.forEach((id) => {
        const initialPos = dragInitialPositionsRef.current?.get(id);
        if (initialPos) {
          finalPositions.push({
            id,
            x: initialPos.x + totalDx,
            y: initialPos.y + totalDy
          });
        }
      });
      if (finalPositions.length === 0) {
        dragInitialPositionsRef.current = null;
        return;
      }
      const snapOffset = getGroupSnapOffset(finalPositions, gridSize);
      const moves = finalPositions.map((pos) => {
        const numericId = getNumericId(pos.id);
        const node = imageNodesRef.current.get(pos.id);
        if (node && numericId > 0) {
          node.x(snapToGrid(pos.x + snapOffset.dx, gridSize));
          node.y(snapToGrid(pos.y + snapOffset.dy, gridSize));
          return {
            objectId: numericId,
            x: snapToGrid(pos.x + snapOffset.dx, gridSize),
            y: snapToGrid(pos.y + snapOffset.dy, gridSize)
          };
        }
        return null;
      }).filter((m) => m !== null);
      batchMoveObjects(moves);
      dragInitialPositionsRef.current = null;
    },
    [wasm, selectedIds, gridSize, moveObject, batchMoveObjects]
  );
  const handleStagePointereDown = useCallback(
    (e) => {
      if (activeTool !== "select") return;
      if (e.target !== e.target.getStage()) return;
      if (isPinchingRef.current) return;
      const stage = stageRef.current;
      if (!stage) return;
      const pos = stage.getPointerPosition();
      if (!pos) return;
      const worldX = (pos.x - stagePos.x) / scale;
      const worldY = (pos.y - stagePos.y) / scale;
      selectionStartRef.current = { x: worldX, y: worldY };
      setIsSelecting(true);
      setSelectionRect({ x: worldX, y: worldY, width: 0, height: 0 });
      if (!e.evt.shiftKey) {
        setSelectedIds([]);
      }
    },
    [activeTool, stagePos, scale]
  );
  const handleStagePointerMove = useCallback(
    (_e) => {
      if (!isSelecting || !selectionStartRef.current) return;
      const stage = stageRef.current;
      if (!stage) return;
      const pos = stage.getPointerPosition();
      if (!pos) return;
      const worldX = (pos.x - stagePos.x) / scale;
      const worldY = (pos.y - stagePos.y) / scale;
      const start = selectionStartRef.current;
      setSelectionRect({
        x: Math.min(start.x, worldX),
        y: Math.min(start.y, worldY),
        width: Math.abs(worldX - start.x),
        height: Math.abs(worldY - start.y)
      });
    },
    [isSelecting, stagePos, scale]
  );
  useCallback(
    (e) => {
      handleStagePointerMove(e);
    },
    [handleStagePointerMove]
  );
  const handleStageTouchMove = useCallback(
    (e) => {
      handleStagePointerMove(e);
    },
    [handleStagePointerMove]
  );
  const handleStagePointerUp = useCallback(
    (e) => {
      if (!isSelecting || !selectionRect) {
        setIsSelecting(false);
        setSelectionRect(null);
        return;
      }
      const newSelectedIds = e.evt.shiftKey ? [...selectedIds] : [];
      images.forEach((img) => {
        const imgRight = img.x + img.width;
        const imgBottom = img.y + img.height;
        const rectRight = selectionRect.x + selectionRect.width;
        const rectBottom = selectionRect.y + selectionRect.height;
        if (!(imgRight < selectionRect.x || img.x > rectRight || imgBottom < selectionRect.y || img.y > rectBottom)) {
          if (!newSelectedIds.includes(img.id)) {
            newSelectedIds.push(img.id);
          }
        }
      });
      setSelectedIds(newSelectedIds);
      setIsSelecting(false);
      setSelectionRect(null);
      selectionStartRef.current = null;
    },
    [isSelecting, selectionRect, images, selectedIds]
  );
  const handleStageMouseUp = useCallback(
    (e) => {
      handleStagePointerUp(e);
    },
    [handleStagePointerUp]
  );
  const handleStageTouchUp = useCallback(
    (e) => {
      handleStagePointerUp(e);
    },
    [handleStagePointerUp]
  );
  const handleStageClick = useCallback(
    (e) => {
      if (e.target === e.target.getStage() && !isSelecting && selectedIds.length > 0) {
        if (!selectionRect) {
          setSelectedIds([]);
        }
      }
    },
    [isSelecting, selectionRect, selectedIds]
  );
  const handleWheel = useCallback(
    (e) => {
      e.evt.preventDefault();
      const stage = stageRef.current;
      if (!stage) return;
      if (e.evt.ctrlKey || e.evt.metaKey) {
        const oldScale = scale;
        const pointer = stage.getPointerPosition();
        if (!pointer) return;
        const scaleBy = 1.1;
        const newScale = e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;
        const clampedScale = Math.max(0.1, Math.min(10, newScale));
        const mousePointTo = {
          x: (pointer.x - stagePos.x) / oldScale,
          y: (pointer.y - stagePos.y) / oldScale
        };
        setScale(clampedScale);
        setStagePos({
          x: pointer.x - mousePointTo.x * clampedScale,
          y: pointer.y - mousePointTo.y * clampedScale
        });
      } else {
        setStagePos({
          x: stagePos.x - e.evt.deltaX,
          y: stagePos.y - e.evt.deltaY
        });
      }
    },
    [scale, stagePos]
  );
  const hammerRef = useRef(null);
  const handleTransformEnd = useCallback(
    (_e) => {
      if (!wasm) return;
      const transformer = transformerRef.current;
      if (!transformer) return;
      const minSize = gridSize * MIN_SIZE_MULTIPLIER;
      const maxSize = gridSize * MAX_SIZE_MULTIPLIER;
      const nodes = transformer.nodes();
      const resizes = [];
      nodes.forEach((node) => {
        const id = node.id();
        const numericId = getNumericId(id);
        if (numericId <= 0) return;
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();
        node.scaleX(1);
        node.scaleY(1);
        const oldWidth = node.width();
        const oldHeight = node.height();
        const aspectRatio = oldWidth / oldHeight;
        let newWidth = snapToGrid(oldWidth * scaleX, gridSize);
        let newHeight = snapToGrid(oldHeight * scaleY, gridSize);
        if (aspectRatio >= 1) {
          if (newWidth > maxSize) {
            newWidth = maxSize;
            newHeight = newWidth / aspectRatio;
          } else if (newWidth < minSize) {
            newHeight = minSize;
            newWidth = newHeight * aspectRatio;
          }
        } else {
          if (newHeight > maxSize) {
            newHeight = maxSize;
            newWidth = newHeight * aspectRatio;
          } else if (newHeight < minSize) {
            newWidth = minSize;
            newHeight = newWidth / aspectRatio;
          }
        }
        const newX = snapToGrid(node.x(), gridSize);
        const newY = snapToGrid(node.y(), gridSize);
        node.width(newWidth);
        node.height(newHeight);
        node.x(newX);
        node.y(newY);
        resizes.push({
          objectId: numericId,
          x: newX,
          y: newY,
          width: newWidth,
          height: newHeight
        });
      });
      if (resizes.length === 1) {
        const r2 = resizes[0];
        resizeObject(r2.objectId, r2.x, r2.y, r2.width, r2.height);
      } else if (resizes.length > 1) {
        batchResizeObjects(resizes);
      }
    },
    [wasm, gridSize, resizeObject, batchResizeObjects]
  );
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }
      if ((e.key === "Delete" || e.key === "Backspace") && selectedIds.length > 0 && wasm) {
        selectedIds.forEach((id) => {
          const numericId = getNumericId(id);
          if (numericId > 0) {
            deleteObject(numericId);
          }
        });
        setSelectedIds([]);
      }
      if ((e.ctrlKey || e.metaKey) && e.key === "a") {
        e.preventDefault();
        setSelectedIds(images.map((img) => img.id));
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [wasm, selectedIds, images, deleteObject]);
  const cursorStyle = activeTool === "pan" ? "grab" : isSelecting ? "crosshair" : "default";
  return /* @__PURE__ */ jsxs("div", { ref: containerRef, style: { position: "absolute", inset: 0, overflow: "hidden", cursor: cursorStyle }, children: [
    /* @__PURE__ */ jsxs(
      Stage,
      {
        ref: stageRef,
        width: dimensions.width,
        height: dimensions.height,
        x: stagePos.x,
        y: stagePos.y,
        scaleX: scale,
        scaleY: scale,
        onClick: handleStageClick,
        onTap: handleStageClick,
        onWheel: handleWheel,
        onPointerDown: handleStagePointereDown,
        onPointerMove: handleStagePointerMove,
        onMouseUp: handleStageMouseUp,
        onTouchMove: handleStageTouchMove,
        onTouchEnd: handleStageTouchUp,
        style: { backgroundColor: "oklch(0.09 0.01 255)" },
        children: [
          /* @__PURE__ */ jsx(Layer, { listening: false, children: /* @__PURE__ */ jsx(
            GridLayer,
            {
              width: dimensions.width,
              height: dimensions.height,
              gridSize,
              stageX: stagePos.x,
              stageY: stagePos.y,
              scale
            }
          ) }),
          /* @__PURE__ */ jsxs(Layer, { children: [
            visibleImages.map((img) => /* @__PURE__ */ jsx(
              CanvasImageNode,
              {
                image: img,
                isSelected: selectedIds.includes(img.id),
                onSelect: (shiftKey) => handleImageSelect(img.id, shiftKey),
                onDragStart: handleDragStart,
                onDragMove: handleDragMove,
                onDragEnd: handleDragEnd,
                activeTool,
                scale,
                isPinching,
                nodeRef: (node) => {
                  if (node) imageNodesRef.current.set(img.id, node);
                  else imageNodesRef.current.delete(img.id);
                }
              },
              img.id
            )),
            /* @__PURE__ */ jsx(
              Transformer,
              {
                ref: transformerRef,
                flipEnabled: false,
                boundBoxFunc: (oldBox, newBox) => {
                  const minSize = gridSize * MIN_SIZE_MULTIPLIER;
                  const maxSize = gridSize * MAX_SIZE_MULTIPLIER;
                  if (Math.abs(newBox.width) < minSize || Math.abs(newBox.height) < minSize) {
                    return oldBox;
                  }
                  if (Math.abs(newBox.width) > maxSize || Math.abs(newBox.height) > maxSize) {
                    return oldBox;
                  }
                  return newBox;
                },
                rotateEnabled: false,
                keepRatio: true,
                enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
                anchorFill: "#4ade80",
                anchorStroke: "#22c55e",
                anchorSize: 10,
                anchorCornerRadius: 2,
                borderStroke: "#4ade80",
                borderStrokeWidth: 2,
                onTransformEnd: handleTransformEnd
              }
            ),
            selectionRect && /* @__PURE__ */ jsx(
              Rect,
              {
                x: selectionRect.x,
                y: selectionRect.y,
                width: selectionRect.width,
                height: selectionRect.height,
                fill: "rgba(74, 222, 128, 0.1)",
                stroke: "#4ade80",
                strokeWidth: 1 / scale,
                dash: [5 / scale, 5 / scale]
              }
            )
          ] })
        ]
      }
    ),
    selectedIds.length > 1 && /* @__PURE__ */ jsxs("div", { className: "absolute bottom-4 left-4 px-3 py-1.5 bg-card/90 backdrop-blur-sm rounded-md text-sm text-foreground border border-border", children: [
      selectedIds.length,
      " items selected"
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "absolute bottom-4 right-4 px-3 py-1.5 bg-card/90 backdrop-blur-sm rounded-md text-xs text-muted-foreground border border-border", children: [
      /* @__PURE__ */ jsx("span", { className: "text-accent", children: "Ctrl+Z" }),
      " Undo \u2022 ",
      /* @__PURE__ */ jsx("span", { className: "text-accent", children: "Ctrl+Shift+Z" }),
      " Redo"
    ] }),
    /* @__PURE__ */ jsx(
      "input",
      {
        ref: fileInputRef,
        type: "file",
        accept: "image/png,image/jpeg,image/jpg",
        multiple: true,
        style: { display: "none" },
        onChange: (e) => handleFileUpload(e.target.files)
      }
    )
  ] });
});

// src/utils/wasmLoader.ts
var wasmInstance = null;
var wasmBinary = null;
async function preloadWASM() {
  if (wasmBinary) return wasmBinary;
  const wasmUrl = new URL("@convadraw/wasm/optimized.wasm", import.meta.url);
  const response = await fetch(wasmUrl);
  wasmBinary = await response.arrayBuffer();
  return wasmBinary;
}
async function loadWASM() {
  if (wasmInstance) return wasmInstance;
  try {
    const binary = await preloadWASM();
    const { instance } = await WebAssembly.instantiate(binary, {
      env: {
        abort: (message, fileName, lineNumber, columnNumber) => {
          console.error("WASM abort:", { message, fileName, lineNumber, columnNumber });
          throw new Error("WASM abort");
        }
      }
    });
    wasmInstance = instance.exports;
    return wasmInstance;
  } catch (error) {
    console.error("Failed to load WASM:", error);
    throw error;
  }
}
var CloudGrid = forwardRef(function CloudGrid2({
  initialAssets,
  gridSize = 25,
  snapToGrid: snapToGrid3 = true,
  showGrid: _showGrid,
  // TODO: Implement grid visibility toggle
  minZoom: _minZoom,
  // TODO: Implement zoom constraints
  maxZoom: _maxZoom,
  // TODO: Implement zoom constraints
  readOnly: _readOnly,
  // TODO: Implement read-only mode
  initialTool = "select",
  toolbarPosition = "top-left",
  statsPanelPosition = "top-right",
  showToolbar = true,
  showStatsPanel = true,
  components = {},
  className,
  style,
  onMount,
  onChange: _onChange,
  // TODO: Wire up WASM state change callbacks
  onSelectionChange: _onSelectionChange,
  // TODO: Wire up selection callbacks
  onViewportChange: _onViewportChange,
  // TODO: Wire up viewport callbacks
  onAssetAdd,
  onAssetUpdate: _onAssetUpdate,
  // TODO: Wire up asset update callbacks
  onAssetDelete: _onAssetDelete,
  // TODO: Wire up asset delete callbacks
  children
}, ref) {
  const containerRef = useRef(null);
  const [error, setError] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const [wasm, setWasm] = useState(null);
  const [activeTool, setActiveTool] = useState(initialTool);
  const [_assets, setAssets] = useState(initialAssets || []);
  const prevStatsRef = useRef({ visible: 0, total: 0, fps: 0 });
  useEffect(() => {
    loadWASM().then(async (wasmInstance2) => {
      wasmInstance2.createCanvas(800, 600, gridSize || 25);
      if (snapToGrid3 !== void 0) wasmInstance2.setGridSnap(snapToGrid3);
      if (gridSize) wasmInstance2.setGridSize(gridSize);
      if (initialAssets && initialAssets.length > 0) {
        const { registerAsset: registerAsset2, setAssetMetadata: setAssetMetadata2 } = await import('./useCanvasStore-DXSML46L.js');
        const { isImageAsset: isImageAsset2, isVideoAsset: isVideoAsset2 } = await import('./assets-VU5RLSSC.js');
        for (const asset of initialAssets) {
          let numericAssetId = 0;
          if (isImageAsset2(asset)) {
            numericAssetId = registerAsset2(asset.src, asset.id);
            if (asset.metadata) {
              setAssetMetadata2(asset.id, asset.metadata, asset.src);
            }
          } else if (isVideoAsset2(asset)) {
            numericAssetId = registerAsset2(asset.src, asset.id);
            if (asset.metadata) {
              setAssetMetadata2(asset.id, asset.metadata, asset.src);
            }
          }
          let objectType = 0;
          if (asset.type === "image") objectType = 1;
          else if (asset.type === "video") objectType = 2;
          else if (asset.type === "text") objectType = 3;
          wasmInstance2.addObject(
            asset.x,
            asset.y,
            asset.w,
            asset.h,
            numericAssetId,
            objectType
          );
        }
      }
      setWasm(wasmInstance2);
    }).catch((err) => {
      setError(err instanceof Error ? err : new Error("Failed to load WASM"));
    });
  }, [initialAssets, gridSize, snapToGrid3]);
  useImperativeHandle(ref, () => ({
    getWASM: () => wasm,
    exportAsJSON: () => {
      return "{}";
    },
    loadFromJSON: (json) => {
      console.log("loadFromJSON not implemented", json);
    },
    loadFromSnapshot: (snapshot) => {
      console.log("loadFromSnapshot not implemented", snapshot);
    }
  }), [wasm]);
  useEffect(() => {
    if (wasm && !isReady) {
      setIsReady(true);
      onMount?.(wasm);
    }
  }, [wasm, isReady, onMount]);
  useEffect(() => {
    const handleAssetsAdded = (e) => {
      const customEvent = e;
      if (customEvent.detail?.assets) {
        const newAssets = customEvent.detail.assets;
        setAssets((prev) => [...prev, ...newAssets]);
        onAssetAdd?.(newAssets);
      }
    };
    window.addEventListener("assets-added", handleAssetsAdded);
    return () => window.removeEventListener("assets-added", handleAssetsAdded);
  }, [onAssetAdd]);
  if (error) {
    const ErrorComponent = components.Error;
    if (ErrorComponent) {
      return /* @__PURE__ */ jsx(ErrorComponent, { error });
    }
    return /* @__PURE__ */ jsxs("div", { className: "cloudgrid-error", style: { padding: 20, color: "red" }, children: [
      "Error: ",
      error.message
    ] });
  }
  if (!wasm || !isReady) {
    const LoadingComponent = components.Loading;
    if (LoadingComponent) {
      return /* @__PURE__ */ jsx(LoadingComponent, {});
    }
    return /* @__PURE__ */ jsx("div", { className: "cloudgrid-loading", style: { padding: 20, color: "white" }, children: "Loading WASM..." });
  }
  const { toolbar, statsPanel, ContextMenu } = components;
  const handleStatsUpdate = (visible, total, fps) => {
    if (prevStatsRef.current.visible !== visible || prevStatsRef.current.total !== total || prevStatsRef.current.fps !== fps) {
      prevStatsRef.current = { visible, total, fps };
    }
  };
  const handleToolChange = (tool) => {
    setActiveTool(tool);
    if (wasm) {
      syncFromWasm(wasm);
    }
  };
  const shouldShowDefaultToolbar = showToolbar && toolbarPosition !== false && toolbar === void 0;
  const toolbarContent = toolbar !== void 0 ? toolbar : shouldShowDefaultToolbar ? /* @__PURE__ */ jsx(
    CompactToolbar,
    {
      activeTool,
      onToolChange: handleToolChange,
      position: toolbarPosition || "top-left"
    }
  ) : null;
  const shouldShowDefaultStatsPanel = showStatsPanel && statsPanelPosition !== false && statsPanel === void 0;
  const statsPanelContent = statsPanel !== void 0 ? statsPanel : shouldShowDefaultStatsPanel ? /* @__PURE__ */ jsx(StatsPanel, { position: statsPanelPosition || "top-right" }) : null;
  return /* @__PURE__ */ jsx(CloudGridContext.Provider, { value: null, children: /* @__PURE__ */ jsx(WasmProvider, { wasm, children: /* @__PURE__ */ jsx(CameraProvider, { wasm, children: /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      className: `cloudgrid-container ${className || ""}`,
      style: {
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        background: "#0a0a0a",
        ...style
      },
      children: [
        /* @__PURE__ */ jsx(
          Canvas,
          {
            wasm,
            activeTool,
            gridSize: gridSize || 25,
            onStatsUpdate: handleStatsUpdate
          }
        ),
        toolbarContent,
        statsPanelContent,
        ContextMenu && /* @__PURE__ */ jsx(ContextMenu, {}),
        children
      ]
    }
  ) }) }) });
});
function DefaultToolbar({ editor }) {
  const [currentTool, setCurrentTool] = useState(editor.getCurrentTool());
  const [canUndo, setCanUndo] = useState(editor.canUndo());
  const [canRedo, setCanRedo] = useState(editor.canRedo());
  const [selectedCount, setSelectedCount] = useState(editor.getSelectedIds().length);
  useEffect(() => {
    const unsubs = [
      editor.on("toolChange", (e) => setCurrentTool(e.data)),
      editor.on("historyChange", () => {
        setCanUndo(editor.canUndo());
        setCanRedo(editor.canRedo());
      }),
      editor.on("selectionChange", () => {
        setSelectedCount(editor.getSelectedIds().length);
      })
    ];
    return () => unsubs.forEach((unsub) => unsub());
  }, [editor]);
  const buttonStyle = {
    padding: "8px 12px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.2s"
  };
  const activeStyle = {
    ...buttonStyle,
    backgroundColor: "#4CAF50",
    color: "white"
  };
  const inactiveStyle = {
    ...buttonStyle,
    backgroundColor: "#e0e0e0",
    color: "#333"
  };
  const disabledStyle = {
    ...buttonStyle,
    backgroundColor: "#f5f5f5",
    color: "#bbb",
    cursor: "not-allowed"
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "cloudgrid-toolbar",
      style: {
        position: "absolute",
        top: 10,
        left: 10,
        zIndex: 100,
        display: "flex",
        gap: "8px",
        padding: "8px",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
      },
      children: [
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "4px" }, children: [
          /* @__PURE__ */ jsxs(
            "button",
            {
              style: currentTool === "select" ? activeStyle : inactiveStyle,
              onClick: () => editor.setCurrentTool("select"),
              title: "Select (V)",
              children: [
                /* @__PURE__ */ jsx(Cursor, { size: 16, weight: "bold", style: { marginRight: 4 } }),
                "Select"
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "button",
            {
              style: currentTool === "pan" ? activeStyle : inactiveStyle,
              onClick: () => editor.setCurrentTool("pan"),
              title: "Pan (H)",
              children: [
                /* @__PURE__ */ jsx(Hand, { size: 16, weight: "bold", style: { marginRight: 4 } }),
                "Pan"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { style: { width: 1, backgroundColor: "#ddd" } }),
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "4px" }, children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              style: canUndo ? inactiveStyle : disabledStyle,
              onClick: () => editor.undo(),
              disabled: !canUndo,
              title: "Undo (Ctrl+Z)",
              children: /* @__PURE__ */ jsx(ArrowCounterClockwise, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              style: canRedo ? inactiveStyle : disabledStyle,
              onClick: () => editor.redo(),
              disabled: !canRedo,
              title: "Redo (Ctrl+Shift+Z)",
              children: /* @__PURE__ */ jsx(ArrowClockwise, { size: 16, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { style: { width: 1, backgroundColor: "#ddd" } }),
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "4px" }, children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              style: inactiveStyle,
              onClick: () => editor.zoomOut(),
              title: "Zoom Out",
              children: /* @__PURE__ */ jsx(MagnifyingGlassMinus, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              style: inactiveStyle,
              onClick: () => editor.zoomIn(),
              title: "Zoom In",
              children: /* @__PURE__ */ jsx(MagnifyingGlassPlus, { size: 16, weight: "bold" })
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              style: inactiveStyle,
              onClick: () => editor.zoomToFit(),
              title: "Fit to Content",
              children: /* @__PURE__ */ jsx(ArrowsOutSimple, { size: 16, weight: "bold" })
            }
          )
        ] }),
        selectedCount > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { style: { width: 1, backgroundColor: "#ddd" } }),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
            /* @__PURE__ */ jsxs("span", { style: { fontSize: "14px", color: "#666" }, children: [
              selectedCount,
              " selected"
            ] }),
            /* @__PURE__ */ jsxs(
              "button",
              {
                style: { ...inactiveStyle, backgroundColor: "#ff5252", color: "white" },
                onClick: () => editor.deleteSelected(),
                title: "Delete Selected",
                children: [
                  /* @__PURE__ */ jsx(Trash, { size: 16, weight: "bold", style: { marginRight: 4 } }),
                  "Delete"
                ]
              }
            )
          ] })
        ] })
      ]
    }
  );
}
function WASMToolbar({ wasm, activeTool = "select", onToolChange }) {
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);
  const [objectCount, setObjectCount] = useState(0);
  const [zoom, setZoom] = useState(100);
  useEffect(() => {
    if (!wasm) return;
    const updateState = () => {
      setCanUndo(wasm.canUndo());
      setCanRedo(wasm.canRedo());
      setObjectCount(wasm.getObjectCount());
      setZoom(Math.round(wasm.getCameraZoom() * 100));
    };
    updateState();
    const interval = setInterval(updateState, 100);
    return () => clearInterval(interval);
  }, [wasm]);
  if (!wasm) return null;
  const buttonBase = {
    padding: "8px 12px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    transition: "all 0.15s ease",
    fontWeight: 500
  };
  const toolButton = (isActive) => ({
    ...buttonBase,
    backgroundColor: isActive ? "#4CAF50" : "#2a2a2a",
    color: isActive ? "white" : "#999",
    transform: isActive ? "scale(1.05)" : "scale(1)"
  });
  const actionButton = (disabled = false) => ({
    ...buttonBase,
    backgroundColor: disabled ? "#222" : "#333",
    color: disabled ? "#555" : "#ddd",
    opacity: disabled ? 0.5 : 1,
    cursor: disabled ? "not-allowed" : "pointer"
  });
  const handleToolChange = (tool) => {
    onToolChange?.(tool);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 16px",
        backgroundColor: "#1a1a1a",
        borderBottom: "1px solid #333",
        gap: "16px"
      },
      children: [
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "6px" }, children: [
          /* @__PURE__ */ jsxs(
            "button",
            {
              style: toolButton(activeTool === "select"),
              onClick: () => handleToolChange("select"),
              title: "Select Tool (V)",
              children: [
                /* @__PURE__ */ jsx(Cursor, { size: 18, weight: "bold" }),
                /* @__PURE__ */ jsx("span", { children: "Select" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "button",
            {
              style: toolButton(activeTool === "pan"),
              onClick: () => handleToolChange("pan"),
              title: "Pan Tool (H)",
              children: [
                /* @__PURE__ */ jsx(Hand, { size: 18, weight: "bold" }),
                /* @__PURE__ */ jsx("span", { children: "Pan" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "16px" }, children: [
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "4px" }, children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                style: actionButton(!canUndo),
                onClick: () => canUndo && wasm.undo(),
                disabled: !canUndo,
                title: "Undo (Ctrl+Z)",
                children: /* @__PURE__ */ jsx(ArrowCounterClockwise, { size: 16, weight: "bold" })
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                style: actionButton(!canRedo),
                onClick: () => canRedo && wasm.redo(),
                disabled: !canRedo,
                title: "Redo (Ctrl+Shift+Z)",
                children: /* @__PURE__ */ jsx(ArrowClockwise, { size: 16, weight: "bold" })
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { style: { width: "1px", height: "20px", backgroundColor: "#444" } }),
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "4px", alignItems: "center" }, children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                style: actionButton(),
                onClick: () => wasm.zoom(0.9, 0, 0),
                title: "Zoom Out (-)",
                children: /* @__PURE__ */ jsx(MagnifyingGlassMinus, { size: 16, weight: "bold" })
              }
            ),
            /* @__PURE__ */ jsxs("span", { style: { fontSize: "12px", color: "#999", minWidth: "45px", textAlign: "center" }, children: [
              zoom,
              "%"
            ] }),
            /* @__PURE__ */ jsx(
              "button",
              {
                style: actionButton(),
                onClick: () => wasm.zoom(1.1, 0, 0),
                title: "Zoom In (+)",
                children: /* @__PURE__ */ jsx(MagnifyingGlassPlus, { size: 16, weight: "bold" })
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                style: actionButton(),
                onClick: () => {
                  wasm.zoom(1, 0, 0);
                  const currentX = wasm.getCameraX();
                  const currentY = wasm.getCameraY();
                  wasm.pan(-currentX, -currentY);
                },
                title: "Reset View (0)",
                children: /* @__PURE__ */ jsx(ArrowsOutSimple, { size: 16, weight: "bold" })
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { style: { width: "1px", height: "20px", backgroundColor: "#444" } }),
          /* @__PURE__ */ jsxs("div", { style: { fontSize: "12px", color: "#999" }, children: [
            /* @__PURE__ */ jsx("span", { style: { color: "#4CAF50", fontWeight: 600 }, children: objectCount.toLocaleString() }),
            " ",
            "objects"
          ] })
        ] })
      ]
    }
  );
}

// src/helpers.ts
function selectItems(ids) {
  window.dispatchEvent(new CustomEvent("select-items", { detail: { ids } }));
}
function zoomToSelected() {
  window.dispatchEvent(new CustomEvent("zoom-to-selected"));
}
function zoomToBounds(bounds, _padding, _duration) {
  window.dispatchEvent(new CustomEvent("zoom-to-bounds", { detail: bounds }));
}
function addMedia() {
  window.dispatchEvent(new CustomEvent("add-media"));
}
function deleteSelected() {
  window.dispatchEvent(new CustomEvent("delete-selected"));
}
function sortByColor() {
  window.dispatchEvent(new CustomEvent("sort-by-color"));
}
/*! This is slightly modified version of hammer library to make it work with Konva framework
 * Modified by Anton Lavrenov.
 * Original code:
 * Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 * that version is slightly modified by Anton Lavrenov
 * to make it work with Konva framework
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */

export { Button, CameraProvider, CloudGrid, CloudGridContext, CompactToolbar, DefaultToolbar, StatsPanel, WASMToolbar, WasmProvider, addMedia, buttonVariants, cn, deleteSelected, selectItems, sortByColor, useCamera, useCloudGrid, useCloudGridOptional, useWasm, useWasmRequired, zoomToBounds, zoomToSelected };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map